<template>
    <!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-confusing-v-for-v-if -->
    <div class="markups-popup" :class="{'fullscreen':isFullscreen, 'minimized': isMinimized, 'hidden': isUndefined}">
        <markups-message-popup :type="popupMessageType" :message="popupMessageText" :callback="popupMessageCallback"></markups-message-popup>
        <format-popup @stylechanged="onStyleChanged($event)"></format-popup>
        <stamps-popup @createstamp="onCreateStamp($event)"></stamps-popup>
        <symbols-popup @create-test-blind="onCreateSymbol($event)"></symbols-popup>
        <test-blind-popup @create-test-blind="onCreateTestBlind($event)"></test-blind-popup>
        <link-class-popup :link-classes="linkClasses" @create-markup-link="onCreateMarkupLink($event)"></link-class-popup>

        <div v-if="!isFullscreen" class="markup-header" @mousedown="onHeaderMouseDown($event)">
            <div class="markup-header-text vertical-center">Create/Edit Markup</div>
            <div class="markup-header-btn-group">
                <div class="markup-header-btn fas fa-window-minimize" @click="minimize()"></div>
                <div class="markup-header-btn fa-lg fas fa-times" @click="hidePopup()"></div>
            </div>
        </div>

        <div class="middle-section disable-select">
            <div class="toolbar-btn show-toolbar-btn hidden" @mousedown="onShowToolbar($event)">
                <i class="fas fa-eye vertical-center"></i>
                <span class="vertical-center">Show toolbar</span>
            </div>
            <div class="toolbar-btn close-btn hidden" @mousedown="hidePopup()">
                <span class="vertical-center">Close</span>
            </div>
            <div class="markup-tools" :class="{'justify-content-flex-start' : isPermitModule}" v-if="!isFlutterRunning">
                <markup-tool v-if="areToolsShown"
                             v-for="item in this.leftTools"
                             :key="item.id"
                             :id="item.id"
                             :name="item.name"
                             :icon="item.icon"
                             :disabled="item.disabled"
                             :hidden="item.hidden"
                             :is-document-locked="isDocumentLocked"
                             :disable-if-locked="item.disableIfLocked"
                             @clicked="onMarkupToolClicked(item)">
                </markup-tool>
            </div>
            <div class="markup-tools shape-tools" :class="{hidden : !isShapesToolVisible}" v-if="!isFlutterRunning">
                <markup-tool class="shape"
                             v-if="areToolsShown"
                             v-for="item in this.shapeTools"
                             :key="item.id"
                             :id="item.id"
                             :name="item.name"
                             :icon="item.icon"
                             :disabled="item.disabled"
                             :hidden="item.hidden"
                             :is-document-locked="isDocumentLocked"
                             :disable-if-locked="item.disableIfLocked"
                             @clicked="onMarkupToolClicked(item)">
                </markup-tool>
            </div>
            <div id="markup-viewer" :style="{width: viewerWidth}">
                <loading-popup :show="isMarkupsSaving && !isFlutterRunning" :text="'Your markups are being saved.'"></loading-popup>
                <div v-show="isMarkupSelected" class="markup-delete-floating-button">
                    <div class="fa-lg fas fa-times" @click="onMarkupDelete()"></div>
                </div>
                <div v-show="drawingLinkInfo.isDrawing" class="markup-link-draw-highlight"></div>
                <link-preview-popup v-show="previewingLink"
                                    ref="linkpreview"
                                    :id="previewingLink ? previewingLink.id : null"
                                    :link="previewingLink" :viewer="markupViewer"
                                    :has_selector_box="true"
                                    @onlinkopen="onMarkupLinkOpen($event)"
                                    @onlinkpreviewclick="onMarkupLinkClick($event, previewingLink)"
                                    @ondeletelink="onDeleteMarkupLink($event)">
                </link-preview-popup>
            </div>
            <div class="right-side-wrap" :style="{ width: rightPanelWrapWidth }">
                <markups-right-panel class="w-100" ref="rightpanel" :viewer="markupViewer"></markups-right-panel>
                <markups-comments v-if="!!isCommentsPanelActive" :active_page="activeMarkupPage" @save_new_markup="saveNewMarkup"></markups-comments>
            </div>
            <div class="show-tools-btn" v-if="!areToolsShown" @click="areToolsShown= true">Show Tools</div>
        </div>
        <div class="markup-tools bottom-bar disable-select" v-if="!isFlutterRunning">
            <markup-tool class="bottom"
                         v-if="areToolsShown"
                         v-for="item in renderedBottomTools"
                         :key="item.id"
                         :id="item.id"
                         :name="item.name"
                         :icon="item.icon"
                         :disabled="item.disabled"
                         :hidden="item.hidden"
                         :is-document-locked="isDocumentLocked"
                         :disable-if-locked="item.disableIfLocked"
                         @clicked="onMarkupToolClicked(item)">
            </markup-tool>
        </div>
    </div>
</template>

<script>
    /* eslint-disable no-unused-vars */
    import { ForgeEquipment, ForgePipeline } from '@/scripts/js/forgeModels';
    const THREE = window.THREE;
    const Autodesk = window.Autodesk;
    import $ from 'jquery';
    import { isPermitModule, isParentOrigin, ForgeMessage } from '../../utils/forgeMessageUtils';
    import { getURLParameterVal } from '../../store/helpers';
    import { onMarkupViewerLoaded, onMarkupLinkClickedFlutter, onEditModeLeaveFlutter, getMarkupsComponent, pdfViewerOpenPageByNumber, drawImageOnPlane, onHistoryChangedFlutter, updateMarkupsOnViewer, onSaveFlutter } from '../../scripts/js/forgeviewer';
    import { ForgeAttachment, ForgeMarkupLink, ForgePageMarkup } from '../../scripts/js/forgeModels';
    import { getAttachmentByReference, postAttachment, getAttachment, fetchUserById } from '../../utils/mongoUtils';
    import { rotateViewerCamera, rotateViewerMarkups, getViewerCurrentPdfPagesCount, unloadViewerAllModels } from '../../utils/forgeUtils';
    import { getPipingDrawingLinkUrl, addNewBlindMarkupsToOrigin, getAllPipingDocuments } from '../../utils/testBlindUtils';
    import { PopupStatus, saveAttachmentToDatabase, exportMarkupImageWithModel, exportAttachmentWithMarkupsPdf, isScriptLoaded, loadScript, addMarkupsForPrint, exportMarkupImage, deletePrintMarkups, pad, _addEvent } from '../../scripts/js/forgeService';
    import appConfig from '../../../appConfig';
    // var filesFolderPath = (apiUrl ? apiUrl : '../../') + 'files/';
    export default {
        name: 'markups-popup',
        components: {
            'markup-tool': () => import('./markupTool.vue'),
            'format-popup': () => import('./formatPopup.vue'),
            'stamps-popup': () => import('./stampsPopup.vue'),
            'symbols-popup': () => import('./symbolsPopup.vue'),
            'test-blind-popup': () => import('./testBlindPopup.vue'),
            'link-class-popup': () => import('./linkClassPopup.vue'),
            'link-preview-popup': () => import('./linkPreviewPopup.vue'),
            'markups-message-popup': () => import('./markupsMessagePopup.vue'),
            'markups-right-panel': () => import('./markupsRightPanel.vue'),
            'markups-comments': () => import('./markupsComments.vue'),
            'LoadingPopup': () => import('@/components/common/loadingPopup.vue'),
        },
        data() {
            return {
                // filesFolderPath: filesFolderPath,
                toolbarVisible: false,
                attachment: null,
                activeMarkupPage: null,
                markupViewer: null,
                autodeskMarkupsExtension: null,
                stampsExtension: null,
                planeMesh: null,
                markupScene: "markup-scene",
                markupLayer: "Layer_1",
                color: "#ff0000",
                currentPageNumber: 1,
                currentPageId: '',
                doc: null,
                viewables: [],
                isCropping: false,
                currentCropBox: null,
                popupMessageType: '',
                popupMessageText: '',
                popupMessageCallback: '',
                pipingDocuments: {},
                selectedLinkClass: [],
                previewingLink: null,
                cameraPosition: -1,
                cameraMaxZ: 20,
                isMarkupSelected: false,
                selectedMarkup: null,
                isMarkupsSaving: false,
                user: null,
                isPermitModule: isPermitModule(),
                movingPopupInfo: {
                    isMoving: false,
                    x: 0,
                    y: 0,
                    left: 0,
                    top: 0,
                },
                drawingLinkInfo: {
                    isDrawing: false,
                    x1: 0,
                    y1: 0,
                    x2: 0,
                    y2: 0,
                },
                leftTools: [{
                    id: "text",
                    name: "Text",
                    icon: this.getIcon("text"),
                    disabled: false,
                    disableIfLocked: true,
                },
                {
                    id: "shapes",
                    name: "Shapes",
                    icon: this.getIcon("shapes"),
                    disabled: false,
                    disableIfLocked: true,
                },
                {
                    id: "highlight",
                    name: "Highlight",
                    icon: this.getIcon("highlight"),
                    disabled: false,
                    disableIfLocked: true,
                },
                {
                    id: "format",
                    name: "Format",
                    icon: this.getIcon("format"),
                    hidden: isPermitModule(),
                    disabled: false,
                    disableIfLocked: true,
                },
                {
                    id: "mask",
                    name: "Mask",
                    icon: this.getIcon("mask"),
                    hidden: isPermitModule(),
                    disabled: false,
                    disableIfLocked: true,
                },
                {
                    id: "stamp",
                    name: "Stamp",
                    icon: this.getIcon("stamp"),
                    hidden: isPermitModule(),
                    disabled: false,
                    disableIfLocked: true,
                },
                {
                    id: "addTestBlind",
                    name: "Test Blind",
                    icon: this.getIcon("addTestBlind"),
                    hidden: true,
                    disabled: false,
                    disableIfLocked: true,
                },
                {
                    id: "symbols",
                    name: "Symbols",
                    icon: this.getIcon("symbol"),
                    hidden: true,
                    disabled: false,
                    disableIfLocked: true,
                },
                ],
                bottomTools: [
                    {
                        id: "link",
                        name: "Link",
                        icon: this.getIcon("link"),
                        hidden: true,
                        disabled: false,
                        disableIfLocked: false,
                    },
                    {
                        id: "comments",
                        name: "Comments",
                        icon: this.getIcon("comments"),
                        hidden: true,
                        disabled: false,
                        disableIfLocked: false,
                    },
                    {
                        id: "thumbnails",
                        name: "Pages View",
                        icon: this.getIcon("thumbnail"),
                        disabled: false,
                        disableIfLocked: false,
                    },
                    {
                        id: "edit",
                        name: "Edit",
                        icon: require('@/images/Edit.png'),
                        disabled: false,
                        disableIfLocked: true,
                    },
                    {
                        id: "screenshot",
                        name: "Download",
                        icon: this.getIcon("screenshot"),
                        disabled: false,
                        disableIfLocked: false,
                    },
                    {
                        id: "undo",
                        name: "Undo",
                        icon: this.getIcon("undo"),
                        disabled: true,
                        disableIfLocked: true,
                    },
                    {
                        id: "redo",
                        name: "Redo",
                        icon: this.getIcon("redo"),
                        disabled: true,
                        disableIfLocked: false,
                    },
                    {
                        id: "rotate-right",
                        name: "Rotate",
                        icon: require('@/images/rotate.png'),
                        hidden: isParentOrigin(),
                        disabled: false,
                        disableIfLocked: false,
                    },
                    {
                        id: "delete",
                        name: "Delete",
                        icon: this.getIcon("delete"),
                        disabled: false,
                        disableIfLocked: true,
                    },
                    // {
                    //     id: "filter",
                    //     name: "Layers",
                    //     icon: require('@/images/markupTools/filter.svg'),
                    //     disabled: true
                    // },
                    {
                        id: "history",
                        name: "History",
                        icon: this.getIcon("history"),
                        disabled: false,
                        disableIfLocked: false,
                    },
                    {
                        id: "relatedDocuments",
                        name: "Related Documents",
                        hidden: !isParentOrigin(),
                        icon: require('@/images/Doc_Hub_-_Selected.png'),
                        disabled: false,
                        disableIfLocked: false,
                    },
                    {
                        id: "discard",
                        name: "Discard",
                        icon: this.getIcon("discard"),
                        disabled: false,
                        disableIfLocked: true,
                    },
                    {
                        id: "lockToggle",
                        name: "",
                        icon: "",
                        disabled: false,
                        disableIfLocked: false,
                    },
                    {
                        id: "save",
                        name: "Save",
                        icon: this.getIcon("save"),
                        disabled: false,
                        disableIfLocked: true,
                    },
                ],
                shapeTools: [{
                    id: "cloud",
                    name: "Cloud",
                    icon: this.getIcon("cloud"),
                    disabled: false,
                    disableIfLocked: true,
                },
                {
                    id: "circle",
                    name: "Ellipse",
                    icon: this.getIcon("ellipse"),
                    disabled: false,
                    disableIfLocked: true,
                },
                {
                    id: "polyline",
                    name: "polyline",
                    icon: this.getIcon("polyline"),
                    disabled: false,
                    disableIfLocked: true,
                },
                {
                    id: "rectangle",
                    name: "Rectangle",
                    icon: this.getIcon("rectangle"),
                    disabled: false,
                    disableIfLocked: true,
                },
                {
                    id: "line",
                    name: "Line",
                    icon: this.getIcon("line"),
                    disabled: false,
                    disableIfLocked: true,
                },
                {
                    id: "arrow",
                    name: "Arrow",
                    icon: this.getIcon("arrow"),
                    disabled: false,
                    disableIfLocked: true,
                },
                {
                    id: "callout",
                    name: "Callout",
                    icon: require('@/images/markupTools/callout.png'),
                    disabled: false,
                    disableIfLocked: true,
                },
                {
                    id: "polycloud",
                    name: "Polycloud",
                    icon: require('@/images/markupTools/polycloud.png'),
                    disabled: false,
                    disableIfLocked: true,
                },
                {
                    id: "freehand",
                    name: "Freehand",
                    icon: require('@/images/markupTools/freehand.png'),
                    disabled: false,
                    disableIfLocked: true,
                },
                ],
                currentMarkupsStyle: {
                    "stroke-color": "#000000",
                    "stroke-opacity": 1.0,
                    "stroke-width": 0.15,
                    "fill-color": "#000000",
                    "fill-opacity": 0,
                    "font-size": 20 /*Font Size*/ * 0.0225 /*Font Scale*/,
                    "font-style": "normal",
                    "font-weight": "normal",
                    "font-family": "Arial"
                },
                areToolsShown: false,
            };
        },
        async mounted() {
            this.isCommentsPanelActive = false;
            this.updateAreToolsShown();
            var _this = this;

            if (isParentOrigin()) {
                _this.currentMarkupsStyle = {
                    "stroke-color": "#FACC15",
                    "stroke-opacity": 0.3,
                    "stroke-width": 0.15,
                    "fill-color": "#FACC15",
                    "fill-opacity": 0,
                    "font-size": 20 * 0.0225,
                    "font-style": "normal",
                    "font-weight": "normal",
                    "font-family": "Arial"
                }
            }

            _addEvent(window, 'mousemove', (event) => {
                if (!_this.movingPopupInfo.isMoving)
                    return;

                var markupPopupElem = $('.markups-popup')[0];
                var newLeft = _this.movingPopupInfo.left + (event.clientX - _this.movingPopupInfo.x);
                var newTop = _this.movingPopupInfo.top + (event.clientY - _this.movingPopupInfo.y);
                if (newLeft < 0)
                    newLeft = 0;
                else if (markupPopupElem.offsetWidth + newLeft > markupPopupElem.parentElement.offsetWidth)
                    newLeft = markupPopupElem.parentElement.offsetWidth - markupPopupElem.offsetWidth;
                markupPopupElem.style.left = newLeft + 'px';

                if (newTop < 0)
                    newTop = 0;
                else if (markupPopupElem.offsetHeight + newTop > markupPopupElem.parentElement.offsetHeight)
                    newTop = markupPopupElem.parentElement.offsetHeight - markupPopupElem.offsetHeight;
                markupPopupElem.style.top = newTop + 'px';
            });
            _addEvent(window, 'mouseup', () => {
                _this.movingPopupInfo.isMoving = false;
                if (_this.markupViewer && _this.markupViewer.impl)
                    _this.markupViewer.resize();
            });

            if (_this.user == null) {
                var userId = this.getUserIdFromTokenInUrl();
                try {
                    if (userId != null) {
                        _this.user = await fetchUserById(userId);
                    }
                } catch (err) {
                    console.warn("fetchUserById failed:", err);
                }
            }

            var parentModuleUrl = _this.$store.getters['getParentModuleUrl'];
            var testPackageId = _this.$store.getters['getTestPackageId'];
            if (parentModuleUrl && testPackageId && !parentModuleUrl.toLowerCase().includes('permit')) {
                _this.pipingDocuments = await getAllPipingDocuments(parentModuleUrl, testPackageId);
            }

        },
        methods: {
            updateAreToolsShown() {
                this.areToolsShown = this.$store.state.parentSiteName == 'reality' ? false : true;
            },
            onHeaderMouseDown($event) {
                this.movingPopupInfo = {
                    isMoving: true,
                    left: $event.target.parentElement.offsetLeft,
                    top: $event.target.parentElement.offsetTop,
                    x: $event.clientX,
                    y: $event.clientY
                };
            },
            getIcon(name) {
                return appConfig.IS_FABRICATION
                    ? require(`@/images/markupToolsFabrication/${name}.svg`)
                    : require(`@/images/markupTools/${name}.svg`);
            },
            onShowToolbar($event) {
                $(".markup-tools:not(.shape-tools)")
                    .css("display", "flex")
                    .hide()
                    .fadeIn(200);
                $(".toolbar-btn").hide(200);
            },
            onHideToolbar() {
                var _this = this;
                $(".markup-tools").hide(200);
                $(".toolbar-btn").show(200);
                setTimeout(
                    function () {
                        if (_this.markupViewer?.model?.getSeedUrn() == _this.attachment.url) {
                            _this.markupViewer.resize();
                        }
                    }, 200);
            },
            saveNewMarkup() {
                let page = this.attachment.pagesMarkups.find(o => o.pageId / 1 == this.currentPageNumber / 1);

                if (!page) {
                    page = new ForgePageMarkup();
                    page.pageId = this.currentPageNumber / 1;
                    this.attachment.pagesMarkups.push(page);
                }

                saveAttachmentToDatabase(this.attachment);

                this.activeMarkupPage = page
            },
            onComments() {
                this.isCommentsPanelActive = !this.isCommentsPanelActive;
            },
            onMarkupToolClicked($event) {
                var _this = this;
                var toolId = $event.id;
                var previousActiveTool = this.$store.getters['getMarkupActiveTool'];
                _this.previewingLink = null;
                //if any tool was active and clicked again, deactivate it
                if (previousActiveTool === toolId) {
                    _this.setActiveTool('');
                    _this.autodeskMarkupsExtension.leaveEditMode();
                    if (toolId === 'thumbnails' || toolId === 'relatedDocuments' || this.activeTool === "history") {
                        setTimeout(() => {
                            _this.markupViewer.resize();
                        }, 500);
                    }
                    return;
                } else {
                    if (toolId !== 'comments') {
                        _this.setActiveTool(toolId);
                    }
                }
                //Anyways reveal any css restricting stamps popup from showing
                //it should be only restricted by v-if
                $(".stamps-popup").css("display", "flex");
                $(".testBlind-popup").css("display", "flex");
                $(".symbols-popup").css("display", "flex");

                switch (toolId) {
                    case "shapes":
                        // Handled from the state and component(s)
                        break;
                    case "format":
                        // Handled from the state and component(s)
                        break;
                    case "save":
                        _this.onSave()
                        break;
                    case "discard":
                        _this.onDiscard();
                        break;
                    case "delete":
                        _this.onMarkupDelete();
                        break;
                    case "undo":
                        _this.onUndo();
                        break;
                    case "redo":
                        _this.onRedo();
                        break;
                    case "rotate-right":
                        _this.onRotatePdf(true);
                        break;
                    case "link":
                        // Handled from the state and component(s)
                        break;
                    case "comments":
                        _this.onComments()
                        break;
                    case "filter":
                        // code block
                        break;
                    case "history": {
                        this.fetchHistory(true);
                        this.$nextTick(() => setTimeout(() => this.markupViewer?.resize(), 300));
                        break;
                    }
                    case "lockToggle": {
                        this.fetchHistory(true);
                        this.toggleDocumentLock()
                        break;
                    }
                    case "addTestBlind":
                        // Handled from the state and component(s)
                        break;
                    case "screenshot":
                        _this.exportPDF();
                        _this.setActiveTool('');
                        break;
                    case "thumbnails":
                        setTimeout(() => {
                            _this.$refs.rightpanel.$refs.thumbnaillist.getThumbnails();
                        }, 500);
                        break;
                    case "relatedDocuments":
                        break;
                    case "edit":
                        _this.autodeskMarkupsExtension.enterEditMode(_this.markupLayer);
                        // By default, the enterEditMode is allow the user to create lines, we want to change it to be able to select only by creating an empty tool.
                        _this.autodeskMarkupsExtension.changeEditMode(new Autodesk.Viewing.Extensions.Markups.Core.EditMode(_this.autodeskMarkupsExtension, null, []));
                        break;
                    case "stamp":
                        //stamp
                        break;
                    case "text":
                    case "highlight":
                    case "cloud":
                    case "circle":
                    case "polyline":
                    case "rectangle":
                    case "line":
                    case "arrow":
                    case "callout":
                    case "polycloud":
                    case "freehand":
                    case "mask":
                        _this.startMarkupTool(toolId, _this.markupLayer);
                        break;
                    default:
                }
            },
            fetchHistory(force = false) {
                var _this = this;
                var docId = _this.$store.getters['getActiveAttachment']?.id ?? 0;
                if (docId) return _this.$store.dispatch('FETCH_ATTACHMENT_HISTORY', { documentId: docId, force });
            },
            setActiveTool(id) {
                this.$store.commit('setMarkupActiveTool', id);
            },
            async toggleDocumentLock() {
                var _this = this;

                var nextIsLocked = !this.isDocumentLocked;
                var verb = nextIsLocked ? "lock" : "unlock";

                this.popupMessageType = "warning-circle";
                this.popupMessageText = `Do you want to ${verb} this document?`;

                this.popupMessageCallback = async function (confirmed) {
                    _this.popupMessageType = "";
                    _this.setActiveTool("");
                    if (!confirmed) return;

                    var attachment = _this.$store.getters['getActiveAttachment'];
                    if (!attachment) return;

                    if (!Array.isArray(attachment.pagesMarkups)) {
                        _this.$set(attachment, 'pagesMarkups', []);
                    }

                    attachment.pagesMarkups.forEach(p => {
                        if (!p || typeof p !== 'object') return;
                        if (!Object.prototype.hasOwnProperty.call(p, 'isLocked')) {
                            _this.$set(p, 'isLocked', nextIsLocked);
                        } else {
                            p.isLocked = nextIsLocked;
                        }
                        if (Object.prototype.hasOwnProperty.call(p, 'IsLocked')) {
                            p.IsLocked = nextIsLocked;
                        }
                    });

                    if (!Object.prototype.hasOwnProperty.call(attachment, 'isLocked')) {
                        _this.$set(attachment, 'isLocked', nextIsLocked);
                    } else {
                        attachment.isLocked = nextIsLocked;
                    }
                    attachment.IsLocked = nextIsLocked;
                    attachment.pagesMarkups = attachment.pagesMarkups.slice();

                    var currentPageNumber =
                        _this.currentPageNumber ??
                        attachment.currentPageNumber ??
                        _this.$store.getters?.currentPageNumber ??
                        1;

                    var page = attachment.pagesMarkups.find(p => (p?.pageId ?? p?.PageId) == currentPageNumber);
                    if (!page) {
                        page = { pageId: currentPageNumber };
                        attachment.pagesMarkups.push(page);
                    }

                    var pageHistory = [];
                    try {
                        var raw = page?.historyText;
                        if (Array.isArray(raw)) {
                            pageHistory = raw.slice();
                        } else if (typeof raw === 'string' && raw.trim().length) {
                            pageHistory = JSON.parse(raw);
                        }
                    } catch (e) {
                        console.warn(`Failed to parse historyText for page ${currentPageNumber}; defaulting to []`, e);
                        pageHistory = [];
                    }

                    var size = { x: Math.random() * 4.5 + 0.5, y: Math.random() * 4.5 + 0.5 };
                    var position = { x: Math.random() * 200 - 100, y: Math.random() * 200 - 100 };

                    var lockEntry = {
                        type: nextIsLocked ? "locked" : "unlocked",
                        id: _this.forgeService.newGuid(),
                        fullName: _this.user?.fullname ?? "",
                        userId: _this.user?.id ?? 0,
                        actionTime: _this.getCurrentDateTime(),
                        position,
                        size,
                        isDynamic: false,
                        pageId: currentPageNumber
                    };

                    pageHistory.push(lockEntry);

                    page.historyText = JSON.stringify(pageHistory);

                    try {
                        if (nextIsLocked) {
                            _this.onSave(false, (confirmed) => {
                                if (!confirmed)
                                    saveAttachmentToDatabase(attachment);
                            });
                        } 
                        else {
                            saveAttachmentToDatabase(attachment);
                        }
                    } catch (e) {
                        console.error('Failed to persist lock state', e);
                    }

                    try {
                        var docKey = attachment.id || attachment.documentId;
                        if (docKey) {
                            var combined = [];
                            var seen = new Set();
                            (attachment.pagesMarkups || []).forEach(p => {
                                var arr = [];
                                var raw = p?.historyText;
                                if (Array.isArray(raw)) arr = raw;
                                else if (typeof raw === 'string' && raw.trim().length) {
                                    try { arr = JSON.parse(raw); } catch { arr = []; }
                                }
                                if (Array.isArray(arr)) {
                                    arr.forEach(it => {
                                        var key = it?.id || `${it?.type}|${it?.actionTime}|${it?.pageId || ''}`;
                                        if (!seen.has(key)) {
                                            seen.add(key);
                                            combined.push(it);
                                        }
                                    });
                                }
                            });

                            combined.sort((a, b) => {
                                var ta = new Date(a?.actionTime || 0).getTime();
                                var tb = new Date(b?.actionTime || 0).getTime();
                                return tb - ta;
                            });

                            _this.$store.commit('SET_ATTACHMENT_HISTORY', { documentId: docKey, items: combined });
                        }
                    } catch (e) {
                        console.warn('Failed to refresh combined history cache', e);
                    }
                };
            },
            onEditModeLeave() {
                var _this = this;
                if (_this.isFlutterRunning) {
                    onEditModeLeaveFlutter();
                }
            },
            getStateStyle() {
                var format = this.$store.getters['getActiveMarkupsStyle']
                this.format = format;
            },
            setStateStyle(style) {
                this.$store.commit('setActiveMarkupsStyle', style);
            },
            onStyleChanged(style) {
                var _this = this;
                _this.currentMarkupsStyle = style;
                var extension = _this.autodeskMarkupsExtension;
                if (extension.editMode) {
                    extension.setStyle(style);
                } else {
                    extension.enterEditMode(_this.markupLayer)
                    extension.setStyle(style);
                    extension.leaveEditMode();
                }
                _this.setStateStyle(style);
            },
            onRotatePdf(isClockwise) {
                var _this = this;
                var angle = isClockwise ? Math.PI / 2 : -Math.PI / 2;

                //Rotate Document
                rotateViewerCamera(_this.markupViewer, angle);

                //Rotate Markups
                var ext = _this.autodeskMarkupsExtension;
                if (ext) {
                    rotateViewerMarkups(ext, angle);
                }

                //Rotate Active Page
                var page = _this.activeMarkupPage;
                if (page) {
                    var newAngle = page.rotation + angle;
                    page.rotation = newAngle % (2 * Math.PI);
                }

                _this.setActiveTool("");
            },
            onCreateStamp(stamp) {
                var _this = this;
                var stampId = stamp.id;
                var layerName = _this.markupLayer;
                //get stamp image
                var stampImageSelector = `.stamp-container#${stampId} svg`;
                var stampImage = $(stampImageSelector)[0];
                if (stampImage != null && _this.stampsExtension != null) {
                    //Just to create a new markup layer with LayerName
                    _this.autodeskMarkupsExtension.enterEditMode(); //Enforce Creation of ext.editModeSvgLayerNode to nest new layer in
                    _this.autodeskMarkupsExtension.leaveEditMode(); //Leave edit mode to allow creation of new layer
                    _this.autodeskMarkupsExtension.enterEditMode(layerName);
                    _this.autodeskMarkupsExtension.leaveEditMode(); //Leave edit mode
                    _this.stampsExtension.startDrawingFromSvgText(stamp.svgText, layerName);
                }
                //reset active tool or hide popup
                $(".stamps-popup").css("display", "none");
            },
            onCreateSymbol(symbol) {
                var _this = this;
                var layerName = "Layer_1";

                if (!_this.markupViewer)
                    return;

                //Just to create a new markup layer with LayerName
                _this.autodeskMarkupsExtension.enterEditMode(); //Enforce Creation of ext.editModeSvgLayerNode to nest new layer in
                _this.autodeskMarkupsExtension.leaveEditMode(); //Leave edit mode to be able to do loadMarkups
                _this.autodeskMarkupsExtension.loadMarkups('', layerName); //Enforce create new markups layer
                _this.autodeskMarkupsExtension.enterEditMode(layerName);

                //get stamp image
                if (_this.stampsExtension != null) {
                    var testBlindData = _this.$store.state.MARKUPS.testBlindData;
                    var symbolId = testBlindData.id;
                    var abbreviation = testBlindData.abbreviation;
                    var isSequential = testBlindData.isSequential;
                    if (testBlindData.isCombo) {
                        abbreviation = abbreviation.split(',');
                        isSequential = false;
                    }
                    var upperText = abbreviation ? abbreviation : "XX";
                    switch (symbolId) {
                        case "flag-pid-predefinded":
                            _this.stampsExtension.startDrawingFlagSymbol(layerName, true);
                            break;

                        case "flag-iso-predefinded":
                            _this.stampsExtension.startDrawingFlagSymbol(layerName, false);
                            break;

                        default:
                            _this.stampsExtension.startDrawingTestBlind(upperText, "XXX", layerName, isSequential, testBlindData.isCombo);
                            break;
                    }
                }
                //reset active tool or hide popup
                $(".symbols-popup").css("display", "none");
            },
            onCreateTestBlind(testBlindData) {
                var _this = this;
                var layerName = "Layer_1";

                if (!_this.markupViewer)
                    return;

                //Just to create a new markup layer with LayerName
                _this.autodeskMarkupsExtension.enterEditMode(); //Enforce Creation of ext.editModeSvgLayerNode to nest new layer in
                _this.autodeskMarkupsExtension.leaveEditMode(); //Leave edit mode to allow creation of new layer
                _this.autodeskMarkupsExtension.loadMarkups('', layerName); //Enforce create new markups layer
                _this.autodeskMarkupsExtension.enterEditMode(layerName);

                //get stamp image
                if (_this.stampsExtension != null) {
                    var abbreviation = _this.$store.state.MARKUPS.testBlindData.abbreviation;
                    var isSequential = _this.$store.state.MARKUPS.testBlindData.isSequential;
                    var upperText = abbreviation ? abbreviation : "XX";
                    _this.stampsExtension.startDrawingTestBlind(upperText, "XXX", layerName, isSequential);
                }
                //reset active tool or hide popup
                $(".testBlind-popup").css("display", "none");
            },
            onLinkClassSelected($event) {
                var _this = this;
                if ($event.length > 0) {
                    _this.selectedLinkClass = [...$event];
                }
            },
            onCreateMarkupLink($event) {
                var _this = this;
                _this.selectedLinkDrawing = $event;

                if (_this.autodeskMarkupsExtension && _this.autodeskMarkupsExtension.editMode) {
                    _this.autodeskMarkupsExtension.leaveEditMode();
                }

                _this.markupViewer.canvas.style.cursor = 'crosshair';
                _this.markupViewer.canvas.addEventListener('mousedown', _this.onCreateMarkupLinkMouseDown);
            },
            onCreateMarkupLinkMouseDown(event) {
                event.preventDefault();
                event.stopPropagation();
                var _this = this;
                _this.markupViewer.canvas.removeEventListener('mousedown', _this.onCreateMarkupLinkMouseDown);
                _this.drawingLinkInfo.x1 = event.offsetX;
                _this.drawingLinkInfo.y1 = event.offsetY;
                _this.drawingLinkInfo.isDrawing = true;
                _this.markupViewer.canvas.addEventListener('mouseup', _this.onCreateMarkupLinkMouseUp);
                _this.markupViewer.canvas.addEventListener('mousemove', _this.onCreateMarkupLinkMouseMove);
                document.getElementsByClassName('markup-link-draw-highlight')[0]?.addEventListener('mousemove', _this.onCreateMarkupLinkMouseMove);
            },
            onCreateMarkupLinkMouseMove(event) {
                event.preventDefault();
                event.stopPropagation();
                var _this = this;
                var boundingBox = _this.markupViewer.canvas.getBoundingClientRect();
                _this.drawingLinkInfo.x2 = event.x - boundingBox.x;
                _this.drawingLinkInfo.y2 = event.y - boundingBox.y;

                var left = Math.min(_this.drawingLinkInfo.x1, _this.drawingLinkInfo.x2);
                var top = Math.min(_this.drawingLinkInfo.y1, _this.drawingLinkInfo.y2);
                var width = Math.abs(_this.drawingLinkInfo.x1 - _this.drawingLinkInfo.x2);
                var height = Math.abs(_this.drawingLinkInfo.y1 - _this.drawingLinkInfo.y2);

                var markupLinkDrawHighlight = $('.markup-link-draw-highlight');
                markupLinkDrawHighlight.css('left', + left + 'px');
                markupLinkDrawHighlight.css('top', + top + 'px');
                markupLinkDrawHighlight.css('width', + width + 'px');
                markupLinkDrawHighlight.css('height', + height + 'px');

            },
            async onCreateMarkupLinkMouseUp(event) {
                var _this = this;
                const MINIMUM_LINK_DIMENSION = 25;
                _this.markupViewer.canvas.removeEventListener('mouseup', _this.onCreateMarkupLinkMouseUp);
                _this.markupViewer.canvas.removeEventListener('mousemove', _this.onCreateMarkupLinkMouseMove);
                document.getElementsByClassName('markup-link-draw-highlight')[0]?.removeEventListener('mousemove', _this.onCreateMarkupLinkMouseMove);
                if (!_this.drawingLinkInfo.isDrawing || _this.activeTool != 'linkCreation') {
                    return;
                }
                _this.drawingLinkInfo.isDrawing = false;
                _this.drawingLinkInfo.x2 = event.offsetX;
                _this.drawingLinkInfo.y2 = event.offsetY;
                _this.markupViewer.canvas.style.cursor = 'pointer';

                var attachment = _this.attachment;

                var startWorldPositionObj = _this.markupViewer.clientToWorld(_this.drawingLinkInfo.x1, _this.drawingLinkInfo.y1, true, true);
                var endWorldPositionObj = _this.markupViewer.clientToWorld(_this.drawingLinkInfo.x2, _this.drawingLinkInfo.y2, true, true);
                if (!startWorldPositionObj || !endWorldPositionObj) {
                    return;
                }

                var startWorldPosition = startWorldPositionObj.point;
                var endWorldPosition = endWorldPositionObj.point;

                var centerX = (startWorldPosition.x + endWorldPosition.x) / 2;
                var centerY = (startWorldPosition.y + endWorldPosition.y) / 2;
                var width = Math.abs(startWorldPosition.x - endWorldPosition.x);
                var height = Math.abs(startWorldPosition.y - endWorldPosition.y);

                var clientWidth = Math.abs(_this.drawingLinkInfo.x1 - _this.drawingLinkInfo.x2);
                var clientHeight = Math.abs(_this.drawingLinkInfo.y1 - _this.drawingLinkInfo.y2);
                var isDimensionsValid = false;
                if (clientWidth > MINIMUM_LINK_DIMENSION && clientHeight > MINIMUM_LINK_DIMENSION) {
                    isDimensionsValid = true;
                }
                _this.drawingLinkInfo.x1 = _this.drawingLinkInfo.x2 = 0;
                _this.drawingLinkInfo.y1 = _this.drawingLinkInfo.y2 = 0;

                if (!isDimensionsValid) {
                    //let user start drawing again
                    _this.markupViewer.canvas.style.cursor = 'crosshair';
                    _this.markupViewer.canvas.addEventListener('mousedown', _this.onCreateMarkupLinkMouseDown);
                    return;
                }

                if (!attachment.pagesMarkups) {
                    attachment.pagesMarkups = [];
                }
                let page = attachment.pagesMarkups.find(o => o.pageId / 1 == _this.currentPageNumber / 1);
                if (!page) {
                    page = new ForgePageMarkup();
                    page.pageId = _this.currentPageNumber / 1;
                    attachment.pagesMarkups.push(page);
                }

                if (!page.links) {
                    page.links = [];
                }
                var link = new ForgeMarkupLink();
                link.linkedAttachmentId = _this.selectedLinkDrawing.id;
                if (isParentOrigin()) {
                    link.referenceDocumentId = _this.selectedLinkDrawing.id;
                    link.referenceContextId = _this.selectedLinkDrawing.TestPackageID;
                    link.referenceContentId = _this.selectedLinkDrawing.DocumentOutputID;

                    var dbAttachment = await getAttachmentByReference(link.referenceDocumentId, link.referenceContextId, link.referenceContentId);
                    if (dbAttachment && dbAttachment.id) {
                        link.linkedAttachmentId = dbAttachment.id;
                    } else {
                        dbAttachment = new ForgeAttachment()
                        dbAttachment.guid = link.referenceDocumentId;
                        dbAttachment.referenceDocumentId = link.referenceDocumentId;
                        dbAttachment.referenceContextId = link.referenceContextId;
                        var savedAttachment = await postAttachment(dbAttachment);
                        link.linkedAttachmentId = savedAttachment?.id;
                    }
                }
                link.name = _this.selectedLinkDrawing.displayName;
                link.type = _this.selectedLinkDrawing.type;
                link.metadata = JSON.stringify(_this.selectedLinkDrawing);
                link.position = new THREE.Vector3(centerX, centerY, 0);
                link.width = width;
                link.height = height;
                link.rotation = 0;
                if (_this.selectedLinkDrawing.imgUrl) {
                    link.thumbnailUrl = _this.selectedLinkDrawing.imgUrl;
                } else if (_this.selectedLinkDrawing.thumbnailUrl) {
                    link.thumbnailUrl = _this.selectedLinkDrawing.thumbnailUrl;
                }
                if (page.id) {
                    link.forgePageMarkupId = page.id;
                }
                page.links.push(link);

                var iconOptions = {
                    position: link.position,
                    width: link.width,
                    height: link.height,
                    rotation: link.rotation,
                    differences: null,
                    title: link.name,
                    id: link.id ?? link.linkedAttachmentId,
                    className: "markup-link-popup",
                    forgeViewer: _this.markupViewer,
                    onClick: (e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        _this.onMarkupLinkClick(e, link);
                    },
                    addContent: true,
                    removeTildeSign: true
                }
                this.forgeService.create3DIconToViewer(iconOptions);

                _this.setActiveTool('');
            },
            onDeleteMarkupLink(link) {
                var _this = this;
                if (!link || !link.id) return;
                _this.previewingLink = null;

                //Delete Link From Attachment
                var page = _this.attachment.pagesMarkups.find(o => o.pageId / 1 == _this.currentPageNumber / 1);
                page.links.pop(link);
            },
            onMarkupLinkClick($event, link) {
                var _this = this;
                _this.previewingLink = link;
                onMarkupLinkClickedFlutter(link);
                var element = $event.srcElement;
                if (!element.classList.contains('markup-link-popup')) {
                    element = element.closest('.markup-link-popup');
                }
                _this.$store.commit('setPreviewingLinkElement', element);
                _this.cameraPosition = _this.markupViewer.getCamera().position;
            },
            onMarkupLinkOpen(link) {
                var _this = this;
                _this.link = link;
                console.log('onMarkupLinkOpen', link);
                _this.onSave(false, async () => {
                    if (isParentOrigin()) {
                        let markupsComp = this.$store.state.markupsComponent ? this.$store.state.markupsComponent : getMarkupsComponent();
                        let link = _this.link;

                        let linkMetadata = link.metadata ? JSON.parse(link.metadata) : '';
                        let parentModuleUrl = _this.$store.getters['getParentModuleUrl'];
                        let controller = 'documentrevisionfilepage';
                        let fileUrl = getPipingDrawingLinkUrl(parentModuleUrl, controller, linkMetadata);

                        if (!parentModuleUrl || !fileUrl) {
                            return;
                        }
                        if (linkMetadata.id && linkMetadata.TestPackageID && linkMetadata.DocumentOutputID) {
                            let attachment;
                            if (link.linkedAttachmentId) {
                                attachment = await getAttachment(link.linkedAttachmentId);
                            } else {
                                attachment = await getAttachmentByReference(linkMetadata.id, linkMetadata.TestPackageID, linkMetadata.DocumentOutputID);
                            }
                            if (!attachment || !attachment.id) { //Attachment not in DB yet
                                attachment.referenceDocumentId = linkMetadata.id;
                                attachment.referenceContextId = linkMetadata.TestPackageID;
                                attachment.referenceContentId = linkMetadata.DocumentOutputID;
                                attachment.referencePageNumber = linkMetadata.PageNumber;
                                attachment.absoluteUrl = linkMetadata.AbsolutePath;
                                attachment.name = linkMetadata.DocumentNumber;
                            }
                            attachment.url = fileUrl;

                            _this.$store.commit('setActiveAttachment', attachment);
                            _this.showAttachment(attachment, true, 1);

                            postAttachment(attachment, (attachmentData) => { attachment.id = attachmentData?.id });
                        } else if (link.linkedAttachmentId) {
                            let attachment = await getAttachment(link.linkedAttachmentId);
                            if (!attachment) { console.error(`No Attachment found by ID: ${link.linkedAttachmentId}`) }
                            if (!attachment?.id) { //Attachment not in DB yet
                                attachment.id = link.linkedAttachmentId;
                            }
                            attachment.url = fileUrl;
                            _this.$store.commit('setActiveAttachment', attachment);
                            _this.autodeskMarkupsExtension?.unloadMarkups('Layer_1')
                            _this.markupViewer.finish();
                            _this.markupViewer = null;
                            Autodesk.Viewing.shutdown();
                            _this.showAttachment(attachment, true, 1);
                        }
                    } else {
                        let markupsComp = this.$store.state.markupsComponent ? this.$store.state.markupsComponent : getMarkupsComponent();
                        let link = markupsComp.link;
                        let linkMetadata = JSON.parse(link.metadata);
                        let classId = linkMetadata.classId;
                        let linkedAttachmentId = link.linkedAttachmentId;
                        switch (classId) {
                            case 'attachments':
                                var attachment = await getAttachment(linkedAttachmentId);
                                if (!attachment.id) { //Attachment not in DB yet
                                    attachment.id = linkedAttachmentId;
                                }
                                _this.$store.commit('setActiveAttachment', attachment);
                                _this.autodeskMarkupsExtension?.unloadMarkups('Layer_1')
                                _this.showAttachment(attachment);
                                postAttachment(attachment, () => {
                                    this.$store.dispatch('RequestPIdsLinkedTags');
                                });
                                break;
                            default:
                                break;
                        }
                    }
                })
            },
            show(annotation, markup, pageGuid = null) {
                this.updateAreToolsShown();
                this.$store.commit('setMarkupsPopupStatus', PopupStatus.ACTIVE);
                this.annotation = annotation;
                this.attachment = markup;
                this.shown = true;
                this.isCropping = false;
                this.currentCropBox = null;
                $(".markups-popup").css("display", "flex");
                setTimeout(() => {
                    this.showMarkupInViewer(pageGuid);
                }, 500);
                ForgeMessage.sendMessageToParent('markupsPopupOpened', null)
            },
            showAttachment(attachment, isFullscreen = false, pageNumber = 1) {
                this.isCommentsPanelActive = false;
                this.updateAreToolsShown();
                var _this = this;
                if (!pageNumber || isNaN(pageNumber / 1) || pageNumber < 1) {
                    pageNumber = 1;
                }
                if (isFullscreen) {
                    _this.enterFullscreen();
                    _this.$store.commit('setMarkupsPopupStatus', PopupStatus.FULLSCREEN);
                } else {
                    _this.$store.commit('setMarkupsPopupStatus', PopupStatus.ACTIVE);
                }
                _this.attachment = attachment;
                if (!_this.attachment.pagesMarkups) {
                    _this.attachment.pagesMarkups = [];
                }
                var page;
                var pages = _this.attachment.pagesMarkups.filter(o => o.pageId / 1 == pageNumber / 1);
                if (pages && pages.length) {
                    for (var i = 0; i < pages.length; i++) {
                        let p = pages[i];
                        if (p && p.markupText != "[]") {
                            if (page) {
                                _this.attachment.pagesMarkups.pop(page);
                            }
                            page = p;
                        }
                    }
                } else {
                    page = new ForgePageMarkup();
                    page.pageId = pageNumber / 1;
                    _this.attachment.pagesMarkups.push(page);
                }
                _this.activeMarkupPage = page;
                _this.$store.commit('setActiveAttachmentPage', pageNumber);
                _this.currentPageNumber = pageNumber / 1;
                _this.shown = true;
                _this.isCropping = false;
                _this.currentCropBox = null;
                $(".markups-popup").css("display", "flex");
                $(".screen-overlay").css("display", "block");

                if (!_this.attachment.url) {
                    _this.$store.dispatch({
                        type: "alert_Forge",
                        message: 'Cannot find document'
                    })
                    return;
                }
                setTimeout(() => {
                    if (_this.markupViewer) {
                        _this.openPageByNumber(pageNumber);
                    } else {
                        _this.launchPDFViewer(pageNumber);
                    }
                }, 200);

                $(".markup-tools")
                    .css("display", "flex")
                    .hide()
                    .fadeIn(200);
                $(".toolbar-btn").hide(200);

                ForgeMessage.sendMessageToParent('markupsPopupOpened', null)
                /*
                    Handler from reality should be:
                    var forgeIframe = $('#forgeiFrame')
                    forgeIframe.css('position', 'relative')
                    forgeIframe.css('z-index', '100')
                */
            },
            async exportPDF() {
                var _this = this;
                var fileName = (_this.attachment?.name || _this.$store.state.testPackageNumber || 'MarkupsExport') + '.pdf';

                var source = _this.attachment;
                try {
                    if (_this?.attachment?.id) {
                        var latest = await getAttachment(_this.attachment.id);
                        if (latest) source = latest;
                    }
                } catch (e) {
                    console.log("Cannot refresh attachment. Using local attachment instead.", e);
                }

                exportAttachmentWithMarkupsPdf(source, fileName);
                // exportMarkupImageWithModel(_this.markupViewer, false, true, fileName); // original snapshot
            },
            enterFullscreen() {
                this.$store.commit('setMarkupsPopupStatus', PopupStatus.FULLSCREEN);
            },
            hidePopup() {
                if (this.markupViewer) {
                    this.markupViewer.finish();
                    this.setActiveTool('');
                    this.markupViewer = null;
                }

                this.previewingLink = null;

                if (this.$store.state.pdfviewer) {
                    pdfViewerOpenPageByNumber(this.$store.state.MARKUPS.activeAttachmentPage);
                }

                this.$store.commit('setMarkupsPopupStatus', PopupStatus.HIDDEN);

                this.onHideToolbar();
                $(".markups-popup").css("display", "none");
                $(".screen-overlay").css("display", "none");

                ForgeMessage.sendMessageToParent('markupsPopupClosed', null)
                /*
                    Handler from reality should be:
                    var forgeIframe = $('#forgeiFrame')
                    forgeIframe.css('position', '')
                    forgeIframe.css('z-index', '')
                */

                //Publish Message that Forge Markups Iframe is hidden
                var markupsPopupClosedMessage = new ForgeMessage('markups-popup-closed', null);
                markupsPopupClosedMessage.send();
            },
            minimize() {
                this.$store.commit('setMarkupsPopupStatus', PopupStatus.MINIMIZED);
            },
            startCropping() {
                if (!this.markupViewer)
                    return;
                this.isCropping = !this.isCropping;

                let croppingEx = this.markupViewer.getExtension('Cropping2DExtension');
                let page = this.attachment.pagesMarkups.find(o => o.pageId / 1 == this.currentPageId / 1);
                let box = page ? page.cropBox : null;
                if (!box)
                    box = this.currentCropBox;
                croppingEx.setCropping(box, this.isCropping);
                if (this.isCropping)
                    this.autodeskMarkupsExtension.leaveEditMode();
                else
                    this.autodeskMarkupsExtension.enterEditMode();
            },
            //Default method
            launchPDFViewer(pageNumber = 1) {
                var _this = this;
                var markupViewerContainer = document.getElementById('markup-viewer');
                var pdfUrl = _this.attachment.url;
                if (!pdfUrl)
                    return;
                if (_this.markupViewer) {
                    _this.autodeskMarkupsExtension?.unloadMarkups('Layer_1')
                    _this.markupViewer?.unloadExtension('Autodesk.Viewing.MarkupsCore');
                    _this.markupViewer?.finish();
                }
                var isCropping2DExtLoaded = isScriptLoaded("Cropping2DExtension")
                var extensions = ['Autodesk.DocumentBrowser']
                if (isCropping2DExtLoaded) {
                    extensions.push('Cropping2DExtension');
                }
                Autodesk.Viewing.Initializer({}, () => {
                    //Clear Autodesk Forge Default Authentication Header
                    Autodesk.Viewing.endpoint.HTTP_REQUEST_HEADERS = {};
                    var config = {
                        extensions: extensions,
                        disabledExtensions: {
                            measure: true
                        },
                        skipPropertyDb: false
                    };
                    _this.markupViewer = new Autodesk.Viewing.Private.GuiViewer3D(markupViewerContainer, config);
                    _this.markupViewer.setTheme("light-theme");
                    _this.markupViewer.start();
                    const img = appConfig.IS_FABRICATION ? require('../../images/FabLogoDark.png') : require('../../images/RealityLoader.png');
                    $('.forge-spinner img').attr('src', img);

                    // Clear old thumbnails from the old viewer.
                    _this.$refs.rightpanel.$refs.thumbnaillist?.clearThumbnails();

                    _this.markupViewer.addEventListener(Autodesk.Viewing.MODEL_ROOT_LOADED_EVENT, () => {
                        // if the attachment is pdf then we need to open the thumbnails panel.
                        if (_this.isMarkupImage) {
                            _this.setActiveTool(null);
                        } else {
                            if (!isParentOrigin()) {
                                _this.setActiveTool('thumbnails');
                                setTimeout(() => {
                                    _this.$refs.rightpanel.$refs.thumbnaillist?.getThumbnails();
                                }, 500);
                            }
                        }
                    })

                    let isFirefox = (/Firefox/i.test(navigator.userAgent));
                    var mousewheel = isFirefox ? "DOMMouseScroll" : "mousewheel";
                    _this.markupViewer.canvas.addEventListener(mousewheel, (event) => {
                        var cameraPosition = _this.markupViewer.navigation.getPosition();
                        let delta = isFirefox ? event.detail : event.wheelDelta;
                        var isZooming = delta > 0;
                        if (cameraPosition.z > _this.cameraMaxZ && !isZooming) {
                            event.stopPropagation();
                            event.preventDefault();
                        }
                    }, false);


                    _this.markupViewer.addEventListener(Autodesk.Viewing.CAMERA_CHANGE_EVENT, (e) => {
                        this.forgeService.updateLabelsPositionsByClassName("markup-link-popup", _this.markupViewer)
                        this.forgeService.updateLabelsPositionsByClassName("markups-link-preview-popup-container", _this.markupViewer)
                        this.forgeService.updateLabelsPositionsByClassName("markup-delete-floating-button", _this.markupViewer)
                        this.forgeService.updateLabelsPositionsByClassName("markup-comment", _this.markupViewer)
                        var cameraPosition = e.camera?.position;
                        if (cameraPosition && !cameraPosition.equals(_this.cameraPosition)) {
                            _this.previewingLink = null;
                        }
                    });

                    _this.markupViewer.loadExtension('Autodesk.PDF', {
                        verbosityLevel: 0,
                        enableMSDFText: false,
                        useTextLayer: false,
                        enableHyperlinks: false,
                        enableTextSearch: false,
                    }).then(() => {
                        var url = this.isMarkupImage ? './assets/files/emptyPage.pdf' : pdfUrl;
                        _this.markupViewer.loadModel(url, {
                            page: pageNumber,
                        }, (doc) => {
                            if (_this.isFlutterRunning) {
                                onMarkupViewerLoaded();
                            } else {
                                _this.openPageByNumber(pageNumber); //Just to skip font type issues
                            }
                            _this.getAttachmentPagesCount();
                            _this.cameraMaxZ = 2 * _this.markupViewer.navigation.getCamera().position.z;
                            _this.markupViewer.navigation.setReverseZoomDirection(true);
                            $('#markup-viewer #settingsTools').css('display', 'none');
                            _this.markupViewer.setBackgroundColor(200, 200, 200, 200, 200, 200);
                            let page = _this.activeMarkupPage;

                            var rotation = _this.activeMarkupPage?.rotation;
                            if (rotation) {
                                rotateViewerCamera(_this.markupViewer, rotation);
                            }

                            // remove previous links if any...
                            $(_this.markupViewer.container).find('.markup-link-popup').remove();
                            if (page && page.links && page.links.length > 0) {
                                page.links.forEach((link) => {
                                    var iconOptions = {
                                        position: link.position,
                                        width: link.width,
                                        height: link.height,
                                        rotation: link.rotation,
                                        differences: null,
                                        title: link.name,
                                        id: link.id ?? link.linkedAttachmentId,
                                        className: "markup-link-popup",
                                        forgeViewer: _this.markupViewer,
                                        onClick: (e) => {
                                            e.stopPropagation();
                                            e.preventDefault();
                                            _this.onMarkupLinkClick(e, link);
                                        },
                                        addContent: true,
                                        removeTildeSign: true
                                    }
                                    this.forgeService.create3DIconToViewer(iconOptions);
                                });
                            }

                            _this.markupViewer.loadExtension("Autodesk.Viewing.MarkupsCore").then(function (extension) {
                                _this.autodeskMarkupsExtension = extension;
                                _this.autodeskMarkupsExtension.addEventListener('EVENT_HISTORY_CHANGED', e => _this.onMarkupHistoryChanged(e));
                                _this.autodeskMarkupsExtension.addEventListener('EVENT_MARKUP_SELECTED', e => _this.onMarkupSelect(e));
                                _this.autodeskMarkupsExtension.addEventListener('EVENT_MARKUP_DESELECT', e => _this.onMarkupDeselect(e));
                                _this.autodeskMarkupsExtension.addEventListener('EVENT_HISTORY_CHANGED', e => _this.onHistoryChanged(e));
                                _this.autodeskMarkupsExtension.addEventListener('EVENT_EDITMODE_LEAVE', e => _this.onEditModeLeave());

                                $('html').keydown(function (e) {
                                    if (e.keyCode == 46) {
                                        _this.onDeleteKeyPressed(e)
                                    }
                                });
                                //Enable stamp markup
                                var rootPath = (appConfig.debugMode ? '../../' : appConfig.UI_URL);

                                require(`@/extensions/StampExtension.js`);

                                let ext = _this.markupViewer.getExtension('StampExtension');

                                if (ext) {
                                    _this.stampsExtension = ext;
                                    _this.loadMarkup(_this.attachment);
                                } else {
                                    _this.markupViewer.loadExtension('StampExtension')
                                        .then(function (stampExt) {
                                            _this.stampsExtension = stampExt;
                                            _this.loadMarkup(_this.attachment);
                                        });
                                }

                                //crop
                                let croppingEx = _this.markupViewer.getExtension('Cropping2DExtension');
                                let page = _this.activeMarkupPage;
                                if (page && page.cropBox) {
                                    croppingEx?.setCropBox(page.cropBox);
                                }
                            });
                        });
                    });
                });
            },
            getAttachmentPagesCount() {
                var _this = this;
                var pagesCount = getViewerCurrentPdfPagesCount(_this.markupViewer);
                _this.$store.commit('setActiveAttachmentPagesCount', pagesCount);
                return pagesCount;
            },
            //if document already opened and we want to open another page
            openPageByNumber(pageNumber) {
                var _this = this;
                unloadViewerAllModels(_this.markupViewer);

                if (!pageNumber || isNaN(pageNumber) || pageNumber < 1) {
                    return;
                }

                _this.currentPageNumber = pageNumber / 1;
                _this.$store.commit('setActiveAttachmentPage', pageNumber);

                var pdfUrl = _this.attachment?.url;
                if (!pdfUrl || !_this.markupViewer) {
                    return;
                }

                var attachment = _this.attachment;
                if (attachment.pagesMarkups) {
                    let page = attachment.pagesMarkups.find(o => o.pageId / 1 == pageNumber / 1);
                    if (!page) {
                        page = new ForgePageMarkup();
                        page.pageId = _this.currentPageNumber / 1;
                        _this.attachment.pagesMarkups.push(page);
                    }
                    _this.activeMarkupPage = page;
                }
                var url = _this.isMarkupImage ? './assets/files/emptyPage.pdf' : pdfUrl;
                _this.markupViewer.loadModel(url, {
                    page: pageNumber
                }, (doc) => {

                    //For Flutter app
                    if (_this.isFlutterRunning)
                        onMarkupViewerLoaded();

                    //draw image on plane if image
                    if (_this.isMarkupImage)
                        drawImageOnPlane(pdfUrl, _this.markupViewer)

                    var rotation = _this.activeMarkupPage?.rotation;
                    if (rotation) {
                        rotateViewerCamera(_this.markupViewer, rotation);
                    }
                    _this.loadMarkup(_this.attachment);
                });
            },
            loadMarkup(attachment) {
                var _this = this;
                var page = null;
                var markupArr = [];

                if (attachment?.pagesMarkups) {
                    page = attachment.pagesMarkups.find(o => o.pageId / 1 === _this.currentPageNumber / 1);
                    if (page?.markupText) {
                        markupArr = JSON.parse(page.markupText) || [];
                    }

                    $(_this.markupViewer.container).find('.markup-link-popup').remove();
                    if (page?.links?.length) {
                        page.links.forEach(link => {
                            var iconOptions = {
                                position: link.position, width: link.width, height: link.height, rotation: link.rotation,
                                differences: null, title: link.name, id: link.id ?? link.linkedAttachmentId,
                                className: "markup-link-popup", forgeViewer: _this.markupViewer,
                                onClick: (e) => { e.stopPropagation(); e.preventDefault(); _this.onMarkupLinkClick(e, link); },
                                addContent: true, removeTildeSign: true
                            };
                            _this.forgeService.create3DIconToViewer(iconOptions);
                        });
                    }

                    $(_this.markupViewer.container).find('.markup-comment').remove();
                    if (page?.comments?.length) _this.updateMarkupsComments(page);
                }

                var layerName = 'Layer_1';
                var mc = _this.autodeskMarkupsExtension;
                if (mc) {
                    mc.enterEditMode();
                    mc.leaveEditMode();
                    mc.loadMarkups('', layerName);
                    mc.enterEditMode(layerName);
                    mc.clear();
                    mc.leaveEditMode();
                }

                if (Array.isArray(markupArr) && markupArr.length > 0) {
                    setTimeout(() => _this.restoreMarkupsFromJosn(markupArr, layerName), 500);
                }
            },
            startMarkupTool(toolId, layerName) {
                var _this = this;
                var avmu = Autodesk.Viewing.Extensions.Markups.Core.Utils;
                var markupExtension = _this.autodeskMarkupsExtension;
                var style = avmu.cloneStyle(_this.currentMarkupsStyle);
                if (!_this.markupViewer)
                    return;
                if (_this.isCropping) {
                    _this.isCropping = false;
                    _this.markupViewer.getExtension('Cropping2DExtension').setCropping(null, false);
                }

                //Just to create a new markup layer with LayerName
                markupExtension.enterEditMode(); //Enforce Creation of ext.editModeSvgLayerNode to nest new layer in
                if (!markupExtension.svgLayersMap[layerName]) { //Is layer existing?
                    markupExtension.leaveEditMode(); //Leave edit mode to be able to do loadMarkups
                    markupExtension.loadMarkups('', layerName); //Enforce create new markups layer
                }
                markupExtension.enterEditMode(layerName);

                let tool = '';

                switch (toolId) {
                    case "arrow":
                        tool = new Autodesk.Viewing.Extensions.Markups.Core.EditModeArrow(markupExtension);
                        break;
                    case "rectangle":
                        tool = new Autodesk.Viewing.Extensions.Markups.Core.EditModeRectangle(markupExtension);
                        break;
                    case "circle":
                        tool = new Autodesk.Viewing.Extensions.Markups.Core.EditModeCircle(markupExtension);
                        break;
                    case "polyline":
                        tool = new Autodesk.Viewing.Extensions.Markups.Core.EditModePolyline(markupExtension);
                        break;
                    case "line":
                        var AVMC = Autodesk.Viewing.Extensions.Markups.Core;

                        tool = new AVMC.EditModePolyline(markupExtension);

                        tool.onMouseDown = (event) => {
                            AVMC.EditMode.prototype.onMouseDown.call(tool);

                            if (tool.selectedMarkup && !tool.creating) return;

                            if (tool.creating) {
                                if (tool.movements.length > 1) tool.creationEnd();
                                return;
                            }

                            // Creation process.
                            var editor = tool.editor;
                            var mousePosition = editor.getMousePosition();
                            mousePosition = editor.clientToMarkups(mousePosition.x, mousePosition.y);
                            var size = (tool.size = editor.sizeFromClientToMarkups(1, 1));

                            tool.movements = [mousePosition, mousePosition];
                            editor.beginActionGroup();

                            var markupId = editor.getId();
                            var create = new AVMC.CreatePolyline(
                                editor,
                                markupId,
                                mousePosition,
                                size,
                                0,
                                [{ x: 0, y: 0 }],
                                tool.style
                            );
                            create.execute();

                            tool.selectedMarkup = editor.getMarkup(markupId);
                            tool.creationBegin();
                        };
                        break;
                    case "text":
                        tool = new Autodesk.Viewing.Extensions.Markups.Core.EditModeText(markupExtension);
                        tool.__proto__.onMouseDown = () => _this.onTextToolMouseDown(tool);
                        break;
                    case "cloud":
                        tool = new Autodesk.Viewing.Extensions.Markups.Core.EditModeCloud(markupExtension);
                        break;
                    case "highlight":
                        tool = new Autodesk.Viewing.Extensions.Markups.Core.EditModeHighlight(markupExtension);
                        style['stroke-opacity'] = 0.5;
                        break;
                    case "stamp":
                        tool = new Autodesk.Viewing.Extensions.Markups.Core.EditModeStamp(markupExtension);
                        break;
                    case "callout":
                        tool = new Autodesk.Viewing.Extensions.Markups.Core.EditModeCallout(markupExtension);
                        break;
                    case "dimension":
                        tool = new Autodesk.Viewing.Extensions.Markups.Core.EditModeDimension(markupExtension);
                        break;
                    case "pen":
                        tool = new Autodesk.Viewing.Extensions.Markups.Core.EditModePen(markupExtension);
                        break;
                    case "polycloud":
                        tool = new Autodesk.Viewing.Extensions.Markups.Core.EditModePolycloud(markupExtension);
                        break;
                    case "freehand":
                        tool = new Autodesk.Viewing.Extensions.Markups.Core.EditModeFreehand(markupExtension);
                        break;
                    case "mask":
                        tool = new Autodesk.Viewing.Extensions.Markups.Core.EditModePolyline(markupExtension);
                        style['stroke-width'] = 0.02; //Clear Mask Boundary thickness to be 0.02
                        style['stroke-opacity'] = 0.5; //Mask boundary opacity to be 0.5
                        style['fill-opacity'] = 1; //Make polygon filled
                        style['fill-color'] = "#ffffff"; //Make fill in white to mask whatever behinde
                        break;
                    default:
                        return;
                }

                markupExtension.changeEditMode(tool);
                markupExtension.setStyle(style);
                _this.bottomTools.find(x => x.id == "redo").disabled = _this.isRedoStackEmpty;
                _this.bottomTools.find(x => x.id == "undo").disabled = _this.isUndoStackEmpty;

            },
            onTextToolMouseDown(tool) {
                if (tool.textInputHelper && tool.textInputHelper.isActive()) {
                    tool.textInputHelper.acceptAndExit();
                    return;
                }

                if (tool.selectedMarkup) {
                    return;
                }

                var editor = tool.editor;
                var mousePosition = editor.getMousePosition();
                var clientFontSize = editor.sizeFromMarkupsToClient(0, tool.style['font-size']).y;
                var initialWidth = clientFontSize * 8;
                var initialHeight = clientFontSize * 1;

                // Center position.
                var size = tool.size = editor.sizeFromClientToMarkups(initialWidth, initialHeight);
                var position = editor.positionFromClientToMarkups(
                    mousePosition.x + (initialWidth * 0.5),
                    mousePosition.y + (initialHeight * 0.5));

                tool.creationBegin();
                editor.beginActionGroup();

                // Given the initial width and font size, we assume that the text fits in one line.
                var createText = new Autodesk.Viewing.Extensions.Markups.Core.CreateText(editor, editor.getId(), position, size, '', tool.style);

                createText.execute();
                tool.creationEnd();

                tool.selectedMarkup = editor.getMarkup(createText.targetId);
                tool.textInputHelper && tool.textInputHelper.setActive(tool.selectedMarkup, true);
                tool.editor.actionManager.addEventListener(Autodesk.Viewing.Extensions.Markups.Core.MarkupEvents.EVENT_HISTORY_CHANGED, tool.onHistoryChangeBinded);
            },
            downloadMarkup(item) {
                this.forgeService.downloadMarkup(item);
            },
            updateDeleteButtonPosition() {
                var _this = this;
                if (!_this.selectedMarkup || !_this.selectedMarkup.shape) {
                    return;
                }
                var shape = _this.selectedMarkup.shape;
                var boundingBox = $(shape)[0].getBoundingClientRect();
                if (!boundingBox) {
                    return;
                }
                var deleteButton = $('.markup-delete-floating-button');
                deleteButton.attr('data-x', _this.selectedMarkup.position.x + _this.selectedMarkup.size.x / 2);
                deleteButton.attr('data-y', _this.selectedMarkup.position.y + _this.selectedMarkup.size.y / 2);
                this.forgeService.updateLabelsPositionsByClassName("markup-delete-floating-button", _this.markupViewer)
            },
            onMarkupHistoryChanged(e) {
                var _this = this;
                if (e.type !== "EVENT_HISTORY_CHANGED" || !_this.selectedMarkup) return;
                _this.updateDeleteButtonPosition();
            },
            onMarkupSelect(e) {
                var _this = this;
                if (e.type != "EVENT_MARKUP_SELECTED") {
                    return;
                }
                _this.isMarkupSelected = true;
                _this.selectedMarkup = e.markup;
                _this.updateDeleteButtonPosition();

            },
            onMarkupDeselect(e) {
                var _this = this;
                if (e.type != "EVENT_MARKUP_DESELECT") {
                    return;
                }
                _this.isMarkupSelected = false;
                _this.selectedMarkup = null;
            },
            onDeleteKeyPressed(e) {
                var _this = this;
                var markup = _this.selectedMarkup;
                var markupExtension = _this.autodeskMarkupsExtension;
                if (!markupExtension || !markupExtension.editMode || !markup) {
                    return;
                }

                var testBlindMarkup;
                var testBlindMarkups = _this.$store.state.MARKUPS.testBlindMarkups;
                if (Array.isArray(testBlindMarkups)) {
                    testBlindMarkup = testBlindMarkups.find(o => o?.ForgeMarkupID?.toLowerCase() == markup.id?.toLowerCase());
                    let isBeingDeleted = _this.$store.state.MARKUPS.testBlindsToBeDeleted.find(o => o?.ForgeMarkupID?.toLowerCase() == markup.id?.toLowerCase());
                    if (testBlindMarkup && !isBeingDeleted) {
                        _this.$store.state.MARKUPS.testBlindsToBeDeleted.push(testBlindMarkup);
                    }
                }

                var testBlindMarkupsToBeAdded = _this.$store.state.MARKUPS.testBlindsToBeAdded;
                if (Array.isArray(testBlindMarkupsToBeAdded)) {
                    testBlindMarkup = testBlindMarkupsToBeAdded.find(o => o?.ForgeMarkupID?.toLowerCase() == markup.id?.toLowerCase());
                    if (testBlindMarkup) {
                        testBlindMarkupsToBeAdded.pop(testBlindMarkup)
                    }
                }
                _this.selectedMarkup = null;
            },
            onMarkupDelete() {
                var _this = this;
                var markupExtension = _this.autodeskMarkupsExtension;
                var selection = markupExtension.getSelection();
                if (selection) {
                    markupExtension.deleteMarkup(selection)
                    var testBlindMarkup;
                    var testBlindMarkups = _this.$store.state.MARKUPS.testBlindMarkups;
                    if (Array.isArray(testBlindMarkups)) {
                        testBlindMarkup = testBlindMarkups.find(o => o?.ForgeMarkupID?.toLowerCase() == selection.id?.toLowerCase());
                        if (testBlindMarkup) {
                            _this.$store.state.MARKUPS.testBlindsToBeDeleted.push(testBlindMarkup)
                        }
                    }
                    var testBlindMarkupsToBeAdded = _this.$store.state.MARKUPS.testBlindsToBeAdded;
                    if (Array.isArray(testBlindMarkupsToBeAdded)) {
                        testBlindMarkup = testBlindMarkupsToBeAdded.find(o => o?.ForgeMarkupID?.toLowerCase() == selection.id?.toLowerCase());
                        if (testBlindMarkup) {
                            _this.$store.state.MARKUPS.testBlindsToBeAdded.pop(testBlindMarkup)
                        }
                    }
                }

                var previousActiveTool = this.$store.getters['getMarkupActiveTool'];
                var targetToolId = 'highlight';

                if (previousActiveTool !== targetToolId) {
                    _this.onMarkupToolClicked({
                        id: targetToolId
                    });
                }

            },
            onUndo() {
                var markupExtension = this.autodeskMarkupsExtension;
                if (!markupExtension.isUndoStackEmpty()) {
                    this.autodeskMarkupsExtension.undo();
                }
                this.bottomTools.find(x => x.id == "redo").disabled = this.isRedoStackEmpty;
                this.bottomTools.find(x => x.id == "undo").disabled = this.isUndoStackEmpty;
                this.setActiveTool('');
            },
            onRedo() {
                var markupExtension = this.autodeskMarkupsExtension;
                if (!markupExtension.isRedoStackEmpty()) {
                    this.autodeskMarkupsExtension.redo();
                }
                this.bottomTools.find(x => x.id == "redo").disabled = this.isRedoStackEmpty;
                this.bottomTools.find(x => x.id == "undo").disabled = this.isUndoStackEmpty;
                this.setActiveTool('');
            },
            onHistoryChanged(e) {
                var _this = this;
                _this.bottomTools.find(x => x.id == "redo").disabled = _this.isRedoStackEmpty;
                _this.bottomTools.find(x => x.id == "undo").disabled = _this.isUndoStackEmpty;
                if (_this.isFlutterRunning) {
                    try {
                        var historyStack = {
                            "redo": _this.isRedoStackEmpty,
                            "undo": _this.isUndoStackEmpty
                        };
                        onHistoryChangedFlutter(JSON.stringify(historyStack));
                    } catch (error) {
                        console.error(error)
                    }
                }
            },
            onSave(hidePopup = false, callback) {
                var _this = this;
                var saveConfirmed = false;
                _this.popupMessageType = 'save';
                _this.popupMessageText = 'Do you want to save changes?';

                _this.popupMessageCallback = async function (confirmed) {
                    _this.popupMessageType = '';
                    saveConfirmed = confirmed;
                    _this.setActiveTool('');
                    if (!saveConfirmed) {
                        if (callback) {
                            await callback(saveConfirmed);
                        }
                        return false;
                    }

                    //Clear Markups history upon saving
                    _this.clearMarkupsHistory();

                    //Show save loading screen
                    if (!_this.isFlutterRunning) _this.isMarkupsSaving = true;

                    //adjust markups viewer to fit view, in order to take markups snapshot
                    _this.markupViewer.navigation.FIT_TO_VIEW_VERTICAL_MARGIN = 0
                    _this.markupViewer.navigation.FIT_TO_VIEW_HORIZONTAL_MARGIN = 0
                    var modelBBox = _this.markupViewer.model.getBoundingBox();
                    var modelWidth = Math.abs(modelBBox.max.x - modelBBox.min.x);
                    var modelHeight = Math.abs(modelBBox.max.y - modelBBox.min.y);
                    var boundingBoxCleintSize = _this.autodeskMarkupsExtension.sizeFromMarkupsToClient(modelWidth, modelHeight);
                    _this.markupViewer.clientContainer.style.width = boundingBoxCleintSize.x + 'px';
                    if (_this.isMarkupImage) {
                        let min = new THREE.Vector3(0, 0, 0);
                        let max = new THREE.Vector3(this.$store.state.markupImageWidth, this.$store.state.markupImageHeight, 0);
                        var box = new THREE.Box3(min, max);
                        _this.markupViewer.navigation.fitBounds(true, box, false, true);
                    } else
                        _this.markupViewer.navigation.fitBounds(true, modelBBox, false, true);

                    //01. Cloned version of attachment
                    if (!_this.attachment.pagesMarkups)
                        _this.attachment.pagesMarkups = [];
                    let page = _this.attachment.pagesMarkups.find(o => o.pageId / 1 == _this.currentPageNumber / 1);
                    if (!page) {
                        page = new ForgePageMarkup();
                        page.pageId = _this.currentPageNumber / 1;
                        _this.attachment.pagesMarkups.push(page);
                    }

                    var markupsForPrint = [];

                    if (isParentOrigin()) {
                        //Add Test Blinds To Origin
                        addNewBlindMarkupsToOrigin();

                        //Add print markups to the scene
                        markupsForPrint = await addMarkupsForPrint(_this.markupViewer, _this.autodeskMarkupsExtension);
                    }

                    page.cropBox = _this.markupViewer?.getExtension('Cropping2DExtension')?.cropBox;
                    var markupJson = _this.generateJsonFromMarkups();
                    page.markupText = JSON.stringify(markupJson?.markupText ?? []);
                    page.historyText = JSON.stringify(markupJson?.historyText ?? []);
                    page.IsLocked = _this.isDocumentLocked;

                    if (_this.autodeskMarkupsExtension.editModeSvgLayerNode) {
                        page.svg = _this.autodeskMarkupsExtension.generateData();
                    }

                    if (_this.$store.state.pdfviewer) {
                        updateMarkupsOnViewer(_this.$store.state.pdfviewer, markupJson?.markupText, "Layer_1");
                    }

                    exportMarkupImage(_this.markupViewer, async function (ImageBase64) {
                        page.ImageBase64 = ImageBase64;
                        saveAttachmentToDatabase(_this.attachment);

                        if (callback) {
                            await callback(saveConfirmed);
                        }

                        var att = _this.attachment || _this.$store.getters['getActiveAttachment'];

                        if (att) {
                            if (!Array.isArray(att.pagesMarkups)) att.pagesMarkups = [];
                            att.pagesMarkups = att.pagesMarkups.slice();
                        }

                        _this.isMarkupsSaving = false;
                        if (_this.markupViewer) {
                            _this.markupViewer.clientContainer.style.width = "calc(100% - 300px)";
                            _this.markupViewer.resize();

                            if (isParentOrigin()) {
                                deletePrintMarkups(_this.autodeskMarkupsExtension, markupsForPrint);
                            }
                        }
                    });

                    if (hidePopup) {
                        setTimeout(() => {
                            if (_this.markupViewer) {
                                _this.isMarkupsSaving = false;
                                _this.markupViewer.finish();
                                _this.markupViewer = null;
                            }
                            _this.hidePopup();
                        }, 200);
                    }
                    if (_this.isFlutterRunning) {
                        onSaveFlutter();
                    }

                };
            },
            onDiscard() {
                var _this = this;
                var discardConfirmed = false;
                _this.popupMessageType = 'discard';
                _this.popupMessageText = 'Do you want to discard changes?';
                _this.popupMessageCallback = function (confirmed) {
                    _this.popupMessageType = '';
                    discardConfirmed = confirmed;
                    _this.setActiveTool('');
                    if (!discardConfirmed) {
                        return;
                    }
                    _this.onHideToolbar();
                    _this.hidePopup();
                };
            },
            onFormatClick() {
                $("#markups-format-popup").toggle(200);
            },
            onStampsClick() {
                $(".stamps-popup").toggle(200);
            },
            getCurrentDateTime() {
                var now = new Date();

                var year = now.getFullYear();
                var month = String(now.getMonth() + 1).padStart(2, '0');
                var day = String(now.getDate()).padStart(2, '0');

                var hours = String(now.getHours()).padStart(2, '0');
                var minutes = String(now.getMinutes()).padStart(2, '0');
                var seconds = String(now.getSeconds()).padStart(2, '0');
                var millis = String(now.getMilliseconds()).padStart(3, '0');

                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${millis}`;
            },
            getUserIdFromTokenInUrl() {
                var token = getURLParameterVal('token') ?? window.localStorage.getItem("token");
                if (!token) return null;

                var decoded = this.parseJwt(token);
                if (!decoded || !decoded.connect_user_id) return null;

                return decoded?.connect_user_id;
            },
            parseJwt(token) {
                try {
                    var base64Url = token.split('.')[1];
                    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
                    var jsonPayload = decodeURIComponent(
                        atob(base64)
                            .split('')
                            .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                            .join('')
                    );
                    return JSON.parse(jsonPayload);
                } catch (e) {
                    console.error("Invalid token", e);
                    return null;
                }
            },
            isSameByPosAndSize(a, b) {
                return (
                    a.position?.x === b.position?.x &&
                    a.position?.y === b.position?.y &&
                    a.size?.x === b.size?.x &&
                    a.size?.y === b.size?.y
                );
            },
            generateJsonFromMarkups() {
                var _this = this;

                if (!_this.autodeskMarkupsExtension) return [];

                _this.autodeskMarkupsExtension.leaveEditMode();

                var all = _this.autodeskMarkupsExtension.markups || [];
                var allMarkups = [];
                for (var i = 0; i < all.length; i++) {
                    var item = all[i];
                    if (!item) continue;
                    if (allMarkups.some(q => q.id == item.id)) continue;
                    allMarkups.push(item);
                }

                var attachment = _this.$store.getters['getActiveAttachment'] || {};
                var currentPageNumber =
                    _this.currentPageNumber ??
                    attachment.currentPageNumber ??
                    _this.$store.getters?.currentPageNumber ??
                    1;
                var pageId = currentPageNumber;

                if (!Array.isArray(attachment.pagesMarkups)) {
                    attachment.pagesMarkups = [];
                }
                var page = attachment.pagesMarkups.find(p => (p?.pageId ?? p?.PageId) == pageId);
                if (!page) {
                    page = { pageId };
                    attachment.pagesMarkups.push(page);
                }

                var pageHistory = [];
                try {
                    var raw = page?.historyText;
                    if (Array.isArray(raw)) pageHistory = raw.slice();
                    else if (typeof raw === 'string' && raw.trim().length) pageHistory = JSON.parse(raw);
                } catch (e) {
                    console.warn(`Failed to parse historyText for page ${pageId}; defaulting to []`, e);
                    pageHistory = [];
                }

                var customMarkupsArrToBeSaved = [];
                var newHistoryCandidates = [];

                for (let i = 0; i < allMarkups.length; i++) {
                    var markup = allMarkups[i];

                    if (markup.isTemp) continue;

                    if (markup.type === "stamp" && !markup.customSVG) continue;

                    var markupObj = {};
                    var newGuid = this.forgeService.newGuid();

                    markupObj.type = markup.type;
                    markupObj.id = isNaN(markup.id) ? markup.id : newGuid;
                    markupObj.position = markup.position;
                    markupObj.size = markup.size;
                    markupObj.rotation = markup.rotation;
                    markupObj.style = markup.style;
                    markupObj.locations = markup.locations;
                    markupObj.closed = markup.closed;
                    markupObj.head = markup.head;
                    markupObj.tail = markup.tail;
                    markupObj.text = markup.currentText;
                    markupObj.pageId = pageId;

                    var stampSVG = "";
                    if (markup.customSVG) {
                        stampSVG = Autodesk.Viewing.Extensions.Markups.Core.Utils.svgNodeToString(markup.customSVG);
                        markupObj.svg = stampSVG;
                    }

                    customMarkupsArrToBeSaved.push(markupObj);

                    var historyObj = {
                        type: markup.type,
                        id: isNaN(markup.id) ? markup.id : newGuid,
                        fullName: _this.user?.fullname ?? "",
                        userId: _this.user?.id ?? 0,
                        actionTime: this.getCurrentDateTime(),
                        position: markup.position,
                        size: markup.size,
                        isDynamic: !!stampSVG && stampSVG.includes("D-S"),
                        pageId
                    };

                    newHistoryCandidates.push(historyObj);
                }

                var uniqueNew = newHistoryCandidates.filter(newItem =>
                    !pageHistory.some(existing =>
                        (_this.isSameByPosAndSize?.(existing, newItem) === true) && (existing.type === newItem.type)
                    )
                );

                if (uniqueNew.length) {
                    pageHistory.push(...uniqueNew);
                }

                var isLocked = false;

                if (uniqueNew.some(item => item.isDynamic === true)) {
                    var size = { x: Math.random() * 4.5 + 0.5, y: Math.random() * 4.5 + 0.5 };
                    var position = { x: Math.random() * 200 - 100, y: Math.random() * 200 - 100 };

                    var lockEntry = {
                        type: "locked",
                        id: this.forgeService.newGuid(),
                        fullName: _this.user?.fullname ?? "",
                        userId: _this.user?.id ?? 0,
                        actionTime: this.getCurrentDateTime(),
                        position,
                        size,
                        isDynamic: false,
                        pageId
                    };

                    pageHistory.push(lockEntry);
                    isLocked = true;
                }

                return {
                    markupText: customMarkupsArrToBeSaved,
                    historyText: pageHistory,
                    isLocked
                };
            },
            restoreMarkupsFromJosn(jsonData, layerName = 'Layer_1') {
                var _this = this;
                if (!jsonData)
                    return;
                //Just to create a new markup layer with LayerName
                _this.autodeskMarkupsExtension.enterEditMode(); //Enforce Creation of ext.editModeSvgLayerNode to nest new layer in
                _this.autodeskMarkupsExtension.leaveEditMode(); //Leave edit mode to allow creation of new layer
                _this.autodeskMarkupsExtension.loadMarkups('', layerName); //Enforce create new markups layer

                _this.autodeskMarkupsExtension.enterEditMode(layerName);
                _this.autodeskMarkupsExtension.clear();
                _this.autodeskMarkupsExtension.leaveEditMode();

                var editor = _this.autodeskMarkupsExtension;
                var avemc = Autodesk.Viewing.Extensions.Markups.Core;
                for (var i = 0; i < jsonData.length; i++) {
                    var currentMarkup = jsonData[i];
                    var createMarkup = null;
                    var id = currentMarkup.id;
                    var tail = currentMarkup.tail;
                    var head = currentMarkup.head;
                    var style = currentMarkup.style;
                    var size = currentMarkup.size;
                    var text = currentMarkup.text;
                    var position = currentMarkup.position;
                    var rotation = currentMarkup.rotation;
                    var closed = currentMarkup.closed;
                    var locations = currentMarkup.locations;

                    switch (jsonData[i].type) {
                        case "arrow":
                            createMarkup = new avemc.CreateArrow(editor, id, tail, head, style);
                            break;
                        case "label":
                            createMarkup = new avemc.CreateText(editor, id, position, size, text, style);
                            break;
                        case "ellipse":
                            createMarkup = new avemc.CreateCircle(editor, id, position, size, rotation, style);
                            break;
                        case "cloud":
                            createMarkup = new avemc.CreateCloud(editor, id, position, size, rotation, style);
                            break;
                        case "callout":
                            createMarkup = new avemc.CreateCallout(editor, id, position, size, rotation, style);
                            break;
                        case "rectangle":
                            createMarkup = new avemc.CreateRectangle(editor, id, position, size, rotation, style);
                            break;
                        case "freehand":
                            createMarkup = new avemc.CreateFreehand(editor, id, position, size, rotation, locations, style);
                            break;
                        case "highlight":
                            createMarkup = new avemc.CreateHighlight(editor, id, position, size, rotation, locations, style);
                            break;
                        case "polyline":
                            createMarkup = new avemc.CreatePolyline(editor, id, position, size, rotation, locations, style, closed);
                            break;
                        case "polycloud":
                            createMarkup = new avemc.CreatePolycloud(editor, id, position, size, rotation, locations, style, closed);
                            break;
                        case "stamp":
                            var customSVG = avemc.Utils.stringToSvgNode(currentMarkup.svg)
                            //If Test Blind Markup just check it's sequence
                            var testBlindMarkup;
                            var testBlindMarkups = _this.$store.state.MARKUPS.testBlindMarkups;
                            if (Array.isArray(testBlindMarkups)) {
                                testBlindMarkup = testBlindMarkups.find(o => o?.ForgeMarkupID?.toLowerCase() == id?.toLowerCase());
                                if (testBlindMarkup) {
                                    var sequence = testBlindMarkup.Sequence;
                                    sequence = pad(sequence, 3)
                                    var innerText = customSVG.querySelector('#stamp-text-lower');
                                    if (innerText) {
                                        innerText.innerHTML = sequence;
                                    }
                                }
                            }

                            var { StampCreateAction } = require('../../extensions/StampExtension');

                            createMarkup = new StampCreateAction(editor, id, position, size, rotation, style, customSVG)
                            break;
                    }
                    if (createMarkup) {
                        createMarkup.addToHistory = false;
                        _this.autodeskMarkupsExtension.enterEditMode(layerName);
                        createMarkup.execute();
                    }
                }
                //force clear selection
                _this.autodeskMarkupsExtension.selectMarkup();
                _this.autodeskMarkupsExtension.leaveEditMode();
                _this.clearMarkupsHistory();
            },
            clearMarkupsHistory() {
                var _this = this;
                if (_this.autodeskMarkupsExtension && _this.autodeskMarkupsExtension.actionManager) {
                    _this.autodeskMarkupsExtension.actionManager.undoStack = [];
                    _this.autodeskMarkupsExtension.actionManager.redoStack = [];
                }
            },
            updateMarkupsComments(page) {
                // remove previous comments
                $(this.markupViewer.container).find('.markup-comment').remove();
                if (!page?.comments?.length) return;
                const COMMENT_CLASS = 'markup-comment';
                // create new comments
                page.comments.forEach((comment) => {
                    var iconOptions = {
                        position: comment.position,
                        width: comment.width,
                        height: comment.height,
                        rotation: comment.rotation,
                        differences: null,
                        title: comment.createdBy,
                        id: comment.id,
                        className: COMMENT_CLASS,
                        forgeViewer: this.markupViewer,
                        onClick: (e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            this.$store.commit('SET_IS_COMMENTS_PANEL_ACTIVE', true);
                            this.$store.commit('SET_SELECTED_COMMENT', comment.id);
                        },
                        addContent: false,
                        removeTildeSign: false
                    }
                    this.forgeService.create3DIconToViewer(iconOptions);
                });
                this.forgeService.updateLabelsPositionsByClassName(COMMENT_CLASS, this.markupViewer)
            },
            resizeOnTime(time) {
                setTimeout(() => {
                    if (this.markupViewer) {
                        this.markupViewer.resize();
                    }
                }, time);
            }
        },
        computed: {
            forgeService: {
                get() {
                    return this.$store.state.forgeService;
                }
            },
            isHistoryActive() {
                return this.$store.getters['getMarkupActiveTool'] === 'history';
            },
            rightPanelWrapWidth() {
                return this.isRightMenuActive
                    ? (this.isHistoryActive ? '500px' : '300px')
                    : null;
            },
            isDocumentLocked() {
                var pages = this.$store.getters['getActiveAttachment']?.pagesMarkups || [];
                return pages.some(p => p?.isLocked === true || p?.IsLocked === true);
            },
            renderedBottomTools() {
                return this.bottomTools.map(t =>
                    t.id === "lockToggle"
                        ? {
                            ...t,
                            name: this.isDocumentLocked ? "Unlock" : "Lock",
                            icon: this.isDocumentLocked
                                ? this.getIcon("padlock-unlocked")
                                : this.getIcon("padlock-locked"),
                        }
                        : t
                );
            },
            isFullscreen: function () {
                var status = this.$store.state.MARKUPS.markupsPopupStatus;
                return status?.toLowerCase() == PopupStatus.FULLSCREEN;
            },
            isMinimized: function () {
                var status = this.$store.state.MARKUPS.markupsPopupStatus;
                return status?.toLowerCase() == PopupStatus.MINIMIZED;
            },
            isActive: function () {
                var status = this.$store.state.MARKUPS.markupsPopupStatus;
                var isActive = status?.toLowerCase() == PopupStatus.ACTIVE;
                if (isActive) {
                    this.resizeOnTime(3000);
                }
                return isActive;
            },
            isUndefined: function () {
                var status = this.$store.state.MARKUPS.markupsPopupStatus;
                return status?.toLowerCase() == PopupStatus.UNDEFINED;
            },
            activeTool: function () {
                return this.$store.getters['getMarkupActiveTool'];
            },
            isFormatPopupVisible: function () {
                return this.$store.getters['getMarkupActiveTool'] === 'format';
            },
            isStampsPopupVisible: function () {
                return $(".stamps-popup").css('display') != 'none';
            },
            isShapesToolVisible: function () {
                return this.$store.getters['getMarkupActiveTool'] === "shapes";
            },
            isEditModeActive: function () {
                return this.autodeskMarkupsExtension?.duringEditMode;
            },
            isCommentsPanelActive: {
                set: function (value) {
                    this.$store.commit('SET_IS_COMMENTS_PANEL_ACTIVE', value);
                },
                get: function () {
                    return this.$store.getters['GET_IS_COMMENTS_PANEL_ACTIVE']
                }
            },
            autoTags() {
                return this.$store.getters['GET_EXISTING_AUTOMATIC_TAGS_INFO'];
            },
            linkClasses: function () {
                var _this = this;
                var linkClasses = [];
                //get documents for links
                if (isParentOrigin()) {
                    linkClasses = _this.pipingDocuments;
                } else {
                    //P&IDs
                    var p_Ids = _this.$store.getters['GET_P_IDS'] ?? [];

                    p_Ids = p_Ids.map(p => {
                        return {
                            id: p.documentId,
                            name: p.documentNumber,
                            ...p
                        }
                    })

                    var p_IdsObject = {
                        items: p_Ids,
                        id: "p_Ids",
                        name: "P&ID",
                    }
                    linkClasses.push(p_IdsObject);

                    //Equipment
                    var tags = _this.$store.state.tags ?? [];
                    var tagsObject = {
                        items: tags.concat(_this.autoTags),
                        id: "equipment",
                        name: "Equipment",
                    }
                    linkClasses.push(tagsObject)

                    //Annotations
                    var annotations = _this.$store.state.annotations ?? {};
                    var annotationsObject = {
                        items: annotations,
                        id: "annotation",
                        name: "General",
                    }
                    linkClasses.push(annotationsObject)

                    //Inspections
                    var inspections = _this.$store.state.inspections ?? {};
                    var inspectionsObject = {
                        items: inspections,
                        id: "inspection",
                        name: "Inspection",
                    }
                    linkClasses.push(inspectionsObject)

                    //Scaffolds
                    var scaffolds = _this.$store.state.scaffolds.filter(s => s.isScaffold()) ?? {};
                    var scaffoldsObject = {
                        items: scaffolds,
                        id: "scaffold",
                        name: "Scaffold",
                    }
                    linkClasses.push(scaffoldsObject)

                    //Permits
                    var permits = _this.$store.state.scaffolds.filter(s => s.isPermit()) ?? {};
                    var permitsObject = {
                        items: permits,
                        id: "permit",
                        name: "Permit",
                    }
                    linkClasses.push(permitsObject)

                    //Containers
                    var containers = _this.$store.state.scaffolds.filter(s => s.isContainer()) ?? {};
                    var containersObject = {
                        items: containers,
                        id: "container",
                        name: "Container",
                    }
                    linkClasses.push(containersObject)
                }
                return linkClasses;
            },
            isFlutterRunning: function () {
                return this.$store.getters['getIsFlutterRunning']
            },
            isRedoStackEmpty: function () {
                return this.autodeskMarkupsExtension?.isRedoStackEmpty();
            },
            isUndoStackEmpty: function () {
                return this.autodeskMarkupsExtension?.isUndoStackEmpty();
            },
            isMarkupImage: function () {
                return this.$store.state.isMarkupImage;
            },
            isRightMenuActive: function () {
                return this.activeTool === "relatedDocuments" || this.activeTool === "thumbnails" || this.activeTool === "history"
            },
            viewerWidth: function () {
                if (this.isCommentsPanelActive && this.isRightMenuActive) return 'calc(100% - 965px)';

                if (this.isCommentsPanelActive) return 'calc(100% - 565px)'

                return 'calc(100% - 575px)';
            },
            currentHighlightedTagsFromViewers: function () {
                let data3d = this.$store.getters.get3dThumbnailPopupInfo;
                let data2d = this.$store.getters.get2dThumbnailPopupInfo;
                let data360 = this.$store.getters.get360ThumbnailPopupInfo;

                let tags = [];

                if (data3d.shown) {
                    tags = [...(data3d?.items ?? [])]

                    if (data3d?.item) {
                        tags.push(data3d.item);
                    }
                }

                if (data2d.shown) {
                    tags = [...(data2d?.items ?? [])]

                    if (data2d?.item) {
                        tags.push(data2d.item);
                    }
                }

                if (data360.shown) {
                    tags = [...(data360?.items ?? [])]

                    if (data360?.item) {
                        tags.push(data360.item);
                    }
                }

                let validIds = tags.filter(t => t instanceof ForgeEquipment || t instanceof ForgePipeline).map(t => t.id);

                return validIds;
            },
        },
        watch: {
            isMinimized: function () {
                var status = this.$store.state.MARKUPS.markupsPopupStatus;
                if (status == PopupStatus.ACTIVE || status == PopupStatus.FULLSCREEN) {
                    setTimeout(() => {
                        if (this.markupViewer) {
                            this.markupViewer.resize();
                        }
                    }, 1000);
                } else {
                    this.setActiveTool('');
                }
            },
            viewerWidth: function (oldWidth, newWidth) {
                if (this.markupViewer && oldWidth !== newWidth) {
                    setTimeout(() => this.markupViewer.resize(), 1000)
                }
            },
            isHistoryActive() {
                this.$nextTick(() => this.markupViewer?.resize());
            },
            currentHighlightedTagsFromViewers: function (newIds) {
                const markupLinks = document.querySelectorAll('.markup-link');
                markupLinks.forEach(link => {
                    const id = link.getAttribute('data-metadata');
                    if (newIds.some(v => v == id)) {
                        if (!link.classList.contains('highlighted-markup-link')) {
                            link.classList.add('highlighted-markup-link');
                        }
                    } else {
                        link.classList.remove('highlighted-markup-link');
                    }
                });
            }
        }
    }
</script>

<style>
    .show-tools-btn {
        height: 30px;
        position: absolute;
        top: 58px;
        left: 10px;
        border-radius: 5px;
        color: white;
        background-color: var(--primary-color);
        z-index: 1;
        padding: 4px 30px 0px 30px;
        text-align: center;
        box-sizing: border-box;
        cursor: pointer;
        box-shadow: 0px 4px 8px rgb(0 0 0 / 25%);
    }

    .show-tools-btn:hover {
        background-color: var(--light-primary-color);
    }

    .middle-section {
        display: flex;
        flex-direction: row;
        flex-grow: 1;
        overflow: hidden;
    }

    .markups-popup-underlay.shaded {
        background: black;
        opacity: 30%;
        pointer-events: none;
    }

    .markups-popup {
        height: 90%;
        width: 75%;
        left: calc(50% - 75% / 2);
        display: none;
        flex-direction: column;
        background: #ffffff;
        color: white;
        padding: 0;
        position: absolute;
        overflow: hidden;
        animation-name: markup-animation;
        animation-duration: 0.5s;
        z-index: 10;
        resize: both;
        border-radius: 10px;
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);
    }

        .markups-popup.fullscreen {
            height: 100%;
            width: 100%;
            left: 0;
            top: 0;
            resize: none;
            border-radius: 0;
            animation-name: none;
        }

    .minimized {
        animation-name: markup-minimize-animation;
        animation-timing-function: ease-in-out;
        animation-duration: 2s;
        animation-fill-mode: forwards;
    }

    @keyframes markup-animation {
        from {
            height: 200px;
            width: 285px;
            margin: 20px;
            display: block;
            flex-direction: column;
            background: #ffffff;
            color: white;
            position: absolute;
            overflow: hidden;
            z-index: 10;
            border-radius: 10px;
            box-shadow: 0px 4px 8px rgb(0 0 0 / 25%);
            transform: translate(calc(100vw - 565px), 0px);
            opacity: 0;
        }

        to {
            height: 90%;
            width: 75%;
            left: calc(50% - 75% / 2) !important;
            flex-direction: column;
            background: #ffffff;
            color: white;
            padding: 0;
            position: absolute;
            overflow: hidden;
            z-index: 10;
            resize: both;
            border-radius: 10px;
            box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);
        }
    }

    @keyframes markup-minimize-animation {
        from {
            height: 90%;
            width: 75%;
            left: calc(50% - 75% / 2) !important;
            flex-direction: column;
            background: #ffffff;
            color: white;
            padding: 0;
            position: absolute;
            overflow: hidden;
            z-index: 10;
            resize: both;
            border-radius: 10px;
            box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);
        }

        to {
            height: 200px;
            width: 285px;
            margin: 20px;
            display: block;
            flex-direction: column;
            background: #ffffff;
            color: white;
            position: absolute;
            overflow: hidden;
            z-index: 10;
            border-radius: 10px;
            box-shadow: 0px 4px 8px rgb(0 0 0 / 25%);
            transform: translate(calc(100vw - 565px), 0px);
            opacity: 0;
        }
    }

    .markup-header {
        display: flex;
        background-color: var(--primary-color);
        color: white;
        font-size: 17px;
        padding: 2px;
        position: relative;
        min-height: 42px;
        left: 0px;
        top: 0px;
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);
        border-radius: 0px 0px 4px 4px;
        cursor: move;
        user-select: none;
        z-index: 100;
    }

    .markups-popup.fullscreen > .markup-header {
        display: none;
    }

    .markup-header-text {
        width: 50%;
        left: 20px;
        font-family: var(--main-font);
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        color: #ffffff;
    }

    .markup-header-btn-group {
        display: flex;
        font-weight: 900;
        font-family: cursive;
        color: var(--primary-color);
        text-align: center;
        position: absolute;
        cursor: pointer;
        z-index: 10;
        right: 10px;
        top: 0;
        justify-content: flex-end;
    }

    .markup-header-btn {
        padding-top: 2px;
        background-color: white;
        color: var(--primary-color);
        border-radius: 18pc;
        width: 27px;
        height: 25px;
        text-align: center;
        margin: 10px 5px;
        position: relative;
        cursor: pointer;
    }

        .markup-header-btn:hover {
            color: var(--dark-primary-color);
        }

        .markup-header-btn.fa-times::before {
            content: "\f00d";
            top: 4px;
            position: relative;
        }

    .toolbar-btn {
        background: var(--primary-color);
        border-radius: 5px;
        cursor: pointer;
        position: absolute;
        width: 132px;
        height: 40px;
        right: 30px;
        top: 72px;
        font-size: 14px;
        z-index: 10;
        box-shadow: 4px 4px 8px rgb(0 0 0 / 25%);
    }

        .toolbar-btn.close-btn {
            background: var(--light-primary-color2);
            color: var(--primary-color);
            display: flex;
            justify-content: center;
            top: 120px;
        }

            .toolbar-btn.close-btn:hover {
                background: var(--light-primary-color);
            }

    .show-toolbar-btn:hover {
        background: var(--dark-primary-color);
    }

    .show-toolbar-btn > .fas {
        left: 12px;
    }

    .show-toolbar-btn > span {
        left: 37px;
        font-family: var(--main-font);
    }

    .markup-delete-floating-button {
        position: absolute;
        width: 22px;
        height: 20px;
        margin: 2px;
        z-index: 10;
        text-align: center;
        border-radius: 18pc;
        cursor: pointer;
        font-weight: 500;
        font-size: 12px;
        padding-top: 3px;
        font-family: cursive;
        background-color: #adadad;
        color: white;
    }

        .markup-delete-floating-button:hover {
            background: var(--primary-color);
        }

    .markup-tools {
        display: none;
        z-index: 2;
        box-shadow: 4px -4px 8px rgb(0 0 0 / 3%);
        justify-content: space-evenly;
        align-items: center;
        flex-direction: column;
    }

        .markup-tools.shape-tools {
            left: 69px;
            top: calc(12% + 15px);
            position: absolute;
            align-content: flex-end;
            align-items: flex-end;
            height: fit-content;
            justify-content: center;
            border-radius: 5px;
            box-shadow: 4px 4px 8px rgb(0 0 0 / 25%);
            border: 1px solid rgba(224, 224, 224, 1);
            background: var(--primary-color);
            /*background: linear-gradient(45deg, rgba(173,80,135,1) 9%, rgba(228,176,202,1) 49%, rgba(132,66,105,1) 87%);*/
        }

            .markup-tools.shape-tools .shape:last-child {
                border-bottom: none;
            }

    .img[title="Shapes"]:hover .markup-tools.shape-tools {
        background-color: red;
    }

    .markup-tools.shape-tools > .arrow-left {
        position: absolute;
        top: 20%;
        left: -10px;
        width: 0;
        height: 0;
        border-top: 10px solid transparent;
        border-bottom: 10px solid transparent;
        border-right: 10px solid var(--primary-color);
    }

    .markup-tools.bottom-bar {
        flex-direction: row;
        justify-content: center;
    }

    .justify-content-flex-start {
        justify-content: flex-start !important;
    }

    .vertical-center {
        margin: 0;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
    }

    .left-markup-menu {
        flex-grow: 1;
        display: flex;
        flex-direction: row;
    }

    #markup-viewer {
        position: relative;
        width: calc(100% - 300px);
        flex-grow: 1;
    }

        #markup-viewer #guiviewer3d-toolbar {
            display: none;
        }

    /*Markup Links*/
    .markup-link-draw-highlight {
        display: block;
        position: absolute;
        border-radius: 5px;
        outline: 2px solid rgb(0 0 0 / 30%);
        z-index: 10;
    }

    .markup-comment {
        position: absolute;
        z-index: 1;
        padding: 3px;
        box-sizing: border-box;
        pointer-events: none;
        width: 30px;
        height: 30px;
        background-image: url(../../images/comment.png);
        background-size: cover;
        pointer-events: all;
        cursor: pointer;
    }

    .markup-link-popup, .markup-link {
        position: absolute;
        cursor: pointer;
        height: 30px;
        width: 75px;
        border-radius: 5px;
        outline: 2px solid rgb(0 0 0 / 30%);
        display: flex;
        align-items: center;
    }

        .markup-link-popup:hover, .markup-link:hover {
            background: rgb(0 0 0 / 10%);
            outline: 2px solid rgb(0 0 0 / 30%);
        }

        .markup-link.selected-markup-link {
            box-shadow: 0px 0px 18px 10px #ad508796;
            outline: 2px solid #ad508796;
        }

        .markup-link.highlighted-markup-link {
            box-shadow: 0px 0px 10px 5px #ad50874f;
            outline: 2px solid #ad508757;
        }

        .markup-link-popup .tag-title.dimension-text {
            flex-grow: 0;
            text-overflow: unset;
            color: var(--dark-primary-color);
            white-space: pre-wrap;
            overflow: hidden;
            width: 100%;
            border-radius: 10px;
            height: 100%;
            justify-content: center;
            align-items: center;
            font-weight: 600;
            background: none;
            text-align: center;
            position: absolute;
        }

    /*General*/
    .hidden {
        display: none !important;
    }
</style>